<template>
    <v-dialog 
        v-model="dialog" max-width="990px" persistent overlay-color="black">
            <v-card>
            <v-form v-model="validCitizen" ref="formCitizen">
                 <v-col  cols="12" sm="12" md="12">
                    <v-card outlined>
                        <v-card-title class="text-h5 font-weight-bold">
                            Adicionar cidadão
                            <v-spacer></v-spacer>
                            <v-btn 
                                elevation="0"
                                color="primary"
                                large
                                outlined
                                rounded 
                                @click="close"
                                class="mr-4"
                            ><v-icon left>mdi-close</v-icon>Fechar</v-btn>
                            <v-btn 
                                color="primary"
                                large
                                rounded
                                left
                                elevation="0"
                                @click="add"
                            ><v-icon small left>mdi-content-save-outline</v-icon>Salvar</v-btn>
                            
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                        clearable
                                        v-model="citizen.name"
                                        id="txCitizenName"
                                        label="Nome *"
                                        maxLength="70"
                                        :counter="70"
                                        :rules="[rules.required]"
                                        :disabled="false"
                                        outlined
                                        loading
                                        @keypress="isLettersAndNumbers($event)"
                                        class="inputUpperText"
                                    >
                                        <template v-slot:progress>
                                            <v-progress-linear
                                            :value="progressName"
                                            absolute
                                            height="3"
                                            ></v-progress-linear>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                        clearable
                                        v-model="citizen.socialName"
                                        label="Nome Social"
                                        maxLength="30"
                                        :counter="30"
                                        :disabled="false"
                                        outlined
                                        loading
                                        @keypress="isLettersAndNumbers($event)"
                                        class="inputUpperText"
                                    >
                                        <template v-slot:progress>
                                            <v-progress-linear
                                            :value="progressSocialname"
                                            absolute
                                            height="3"
                                            ></v-progress-linear>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                        clearable
                                        v-model="citizen.motherName"
                                        label="Nome da mãe *"
                                        maxLength="70"
                                        :counter="70"
                                        :rules="[rules.required]"
                                        :disabled="false"
                                        outlined
                                        loading
                                        @keypress="isLettersAndNumbers($event)"
                                        class="inputUpperText"
                                    >
                                        <template v-slot:progress>
                                            <v-progress-linear
                                            :value="progressMothername"
                                            absolute
                                            height="3"
                                            ></v-progress-linear>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field
                                        type="date"
                                        v-model="citizen.birthDate"
                                        label="Data de Nascimento *"
                                        clearable
                                        outlined
                                        @blur="getPresentAge($event.target.value)"
                                        validate-on-blur
                                        :rules="[isValidDate, rules.required]"
                                        id="txBirthDate"
                                    />       
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-select
                                        clearable
                                        :rules="[rules.required]"
                                        item-text="DescricaoTipoSexo"
                                        item-value="TipoSexoId"
                                        :items="listTipoSexo"
                                        v-model="citizen.idGender"
                                        label="Gênero *"
                                        @change="checkIfPregnantFieldEnabled"
                                        outlined
                                    />
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-autocomplete
                                        clearable
                                        :rules="[rules.required]"
                                        item-value="IdentidadeSexualId"
                                        item-text="DescricaoIdentidadeSexual"
                                        :items="listIdentidadeSexual"
                                        v-model="citizen.idGenderIdentity"
                                        label="Identidade de Gênero *"
                                        @change="checkIfPregnantFieldEnabled"
                                        outlined
                                    />
                                </v-col>
                            </v-row>
                            <v-row>

                                <v-col cols="12" sm="12" md="4">
                                    <v-autocomplete
                                        clearable
                                        :rules="[rules.required]"
                                        item-value="RacaId"
                                        item-text="DescricaoRaca"
                                        :items="listRaca"
                                        v-model="citizen.idRace"
                                        label="Raça/Cor *"
                                        outlined
                                    />
                                   
                                </v-col>    
                                <v-col cols="12" sm="12" md="5">
                                    <v-select
                                        outlined
                                        clearable
                                        :items="listGrauDependencia"
                                        v-model="citizen.idDependencyDegree"
                                        label="Grau de Dependência *"
                                        v-show="currentAge >= 60"
                                    /> 
                                </v-col>                                 
                                <v-col cols="12" sm="12" md="3" v-if="showFormPrgnt == true">
                                    <v-checkbox
                                        v-model="citizen.isPregnant"
                                        label="É gestante?"
                                        ></v-checkbox>
                                </v-col>                                                                                          
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="3">
                                    <v-select
                                    outlined
                                    clearable
                                    item-value="Id"
                                    item-text="Descricao"
                                    :items="listNacionalidade"
                                    v-model="citizen.nationality"
                                    @change="manageGroupForeing($event)"
                                    label="Nacionalidade *"
                                     :rules="[rules.required]"
                                    />
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                    <v-autocomplete
                                        outlined
                                        clearable
                                        item-value="PaisOrigemId"
                                        item-text="NomePais"
                                        :items="listPaisFiltrada"
                                        v-model="citizen.DocumentoIdentidadeEstrangeiro.idOriginCountry"
                                        label="País de Origem *"
                                        id="cboPaisOrigem"
                                        :disabled="citizen.nationality < 2"
                                        :rules="[rules.required]"
                                    />
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                    <v-text-field
                                        outlined
                                        clearable
                                        v-model="citizen.DocumentoIdentidadeEstrangeiro.number"
                                        label="Número RNE"
                                        :disabled="false"
                                        maxLength="15"
                                        v-if="citizen.nationality > 1"
                                    />  
                                </v-col>
                                <v-col cols="12" sm="12" md="3">                                       
                                    <v-text-field
                                        outlined
                                        clearable
                                        v-model="citizen.DocumentoIdentidadeEstrangeiro.passport"
                                        label="Número do Passaporte"
                                        :disabled="false"
                                        maxLength="10"
                                        v-if="citizen.nationality > 1"
                                    />    
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <p>Em caso de preenchimento do RG, é necessário preencher os campos Dígito, Órgão Emissor e UF</p>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                    <v-text-field
                                        outlined
                                        clearable
                                        v-model="citizen.DocumentoIdentidade.number"
                                        label="Número do RG"
                                        :disabled="false"
                                        maxLength="15"
                                    /> 
                                </v-col>
                                <v-col cols="12" sm="12" md="2">
                                  <v-text-field
                                        outlined
                                        v-model="citizen.DocumentoIdentidade.digit"
                                        label="Dígito"
                                        :disabled="false"
                                        maxLength="1"
                                    />
                                </v-col>                                  
                                <v-col cols="12" sm="12" md="3">                                     
                                    <v-text-field
                                        outlined
                                        clearable
                                        v-model="citizen.DocumentoIdentidade.issuer"
                                        label="Órgão Emissor"
                                        :disabled="false"
                                        maxLength="5"
                                    />                                         
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                    <v-autocomplete
                                        outlined
                                        clearable
                                        required
                                        item-text="nome"
                                        item-value="sigla"
                                        :items="listState"
                                        v-model="citizen.DocumentoIdentidade.stateAcronym"
                                        label="UF"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <v-text-field-cpf
                                        label="Número do CPF"
                                        v-model="citizen.cpf"
                                        v-bind:properties="{
                                            readonly: false,
                                            disabled: false,
                                            outlined: true,
                                            clearable: true,
                                            placeholder: '',
                                            id: 'numeroDoCPF',
                                        }"
                                        v-bind:options="{
                                            outputMask: '###########',
                                            empty: null,
                                            applyAfter: false,
                                        }"
                                    />      
                                </v-col>
                            </v-row>
                            
                            
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    
                                    <v-checkbox
                                        v-model="certidaoNova"
                                        label="Certidão de nascimento no formato novo?"
                                        @change="checkTipoCertidao"
                                        ></v-checkbox>
                                </v-col>
                            </v-row>
                            
                            <v-row v-if="certidaoNova != true">
                                <v-col cols="12" sm="12" md="12">
                                    <p>Em caso de preenchimento da Certidão de nascimento, é necessário preencher os campos Livro, Folha, UF e Cidade</p>
                                </v-col>
                                <v-col cols="12" sm="12" md="6">                                
                                    <v-text-field
                                        outlined
                                        clearable
                                        v-model="citizen.CertidaoNascimento.number"
                                        label="Número da certidão de nascimento"
                                        :disabled="false"
                                        maxLength="8"
                                    /> 
                                </v-col>                          
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field
                                        outlined
                                        clearable
                                        v-model="citizen.CertidaoNascimento.book"
                                        label="Livro"
                                        :disabled="false"
                                        maxLength="8"
                                    />                                         
                                </v-col>                          
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field
                                        outlined
                                        clearable
                                        v-model="citizen.CertidaoNascimento.page"
                                        label="Folha"
                                        :disabled="false"
                                        maxLength="4"
                                    />                                         
                                </v-col> 
                                <v-col cols="12" sm="12" md="3">
                                    <v-autocomplete
                                        outlined
                                        clearable
                                        required
                                        item-text="nome"
                                        item-value="sigla"
                                        :items="listState"
                                        v-model="citizen.CertidaoNascimento.stateAcronym"
                                        label="UF"
                                        @change="loadCities($event,'certidaoNascimento')"
                                    />
                                </v-col>    
                                <v-col cols="12" sm="12" md="9">
                                    <v-autocomplete
                                        outlined
                                        clearable
                                        item-value="CidadeId"
                                        item-text="NomeCidade"
                                        :items="listCityCertidaoNascimento"
                                        v-model="citizen.CertidaoNascimento.idCity"
                                        label="Cidade"
                                    />
                                </v-col>                                              
                            </v-row>
                            <v-row v-else>
                                <v-col cols="12" sm="12" md="12">                                
                                    <v-text-field
                                        outlined
                                        clearable
                                        v-model="citizen.CertidaoNascimento.numberNew"
                                        label="Certidão de nascimento"
                                        :disabled="false"
                                        maxLength="40"
                                    /> 
                                </v-col> 
                            </v-row>
                        </v-card-text>              
                    </v-card>
                </v-col>

                <v-col  cols="12" sm="12" md="12">
                    <v-card outlined>
                        <v-card-title class="text-h5 font-weight-bold"> 
                            Acessibilidade e autonomia
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="12" md="12" lg="12">
                                    <div>Necessita vaga acessível? *</div>
                                    <v-radio-group
                                    v-model="citizen.isAcessibleSpace"
                                    
                                    row
                                    >
                                    <template v-slot:label>
                                        
                                    </template>
                                    <v-radio
                                        label="Não"
                                        value="0"
                                        @click="radioClick('acSpc_N')"
                                    ></v-radio> 
                                    <v-radio
                                        label="Sim"
                                        value="1"
                                        @click="radioClick('acSpc_S')"
                                    ></v-radio>     
                              
                                    </v-radio-group>
                                    <v-textarea 
                                        v-if="citizen.isAcessibleSpace == '1'"
                                        outlined
                                        no-resize
                                        clearable
                                        rows="2"
                                        rows-height="3"
                                        label="Justificativa para leito baixo acessível *"
                                        v-model="citizen.acessibleSpaceDescription"
                                        :counter="500"
                                        maxlength="500"
                                    />  
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12" lg="12">
                                    <div>Necessita de cuidados de terceiros? *</div>
                                    <v-radio-group
                                    v-model="citizen.hasThirdpartyCare"
                                    
                                    row
                                    >
                                        <template v-slot:label>
                                            
                                        </template>  
                                        <v-radio
                                            label="Não"
                                            value="0"
                                            @click="radioClick('trdPrt_N')"
                                        ></v-radio>                                       
                                        <v-radio
                                            label="Sim"
                                            value="1"
                                            @click="radioClick('trdPrt_S')"
                                        ></v-radio>                                
                                    </v-radio-group>   
                                
                                    <div
                                        v-show="isTrueValue(citizen.hasThirdpartyCare)"
                                    >       
                                        <v-col cols="12" sm="12" md="12" lg="12">
                                            <v-btn color="secondary"
                                                elevation="0"
                                                large
                                                outlined
                                                rounded @click="openAddThirdPartyCare">
                                            <v-icon small left>mdi-plus-box</v-icon>
                                            ADICIONAR</v-btn>
                                            <modalAddThirdPartyCare ref="mdThirdPartyCare" :dialog.sync="showModalThirdPartyCare" />
                                        </v-col>
                                    </div> 
                                    <div id="divListCareTypes" v-show="isTrueValue(citizen.hasThirdpartyCare)" xs6>
                                        <v-chip-group v-if="citizen.careTypes.length > 0"
                                            column 
                                            multiple
                                        >
                                            <v-chip 
                                            outlined
                                            label
                                            close
                                            close-icon="mdi-close"
                                            class="primary"
                                            v-for="(disab, index) in citizen.careTypes" 
                                            :key="'tcp_'+disab.FormaCuidadoId+'_'+index"
                                            @click:close="removeThirdPartyCare(disab.FormaCuidadoId)">
                                                {{ disab.DescricaoForma }}
                                            </v-chip>
                                        </v-chip-group>
                                        <v-chip v-else
                                            small 
                                            color="primary" 
                                            label
                                        >Nenhuma informação encontrada</v-chip>
                                    </div>  
                                </v-col>                               
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="12" md="6">
                                    <div>Possui deficiências? *</div>
                                    <v-radio-group
                                    v-model="citizen.hasDisability"
                                    
                                    row
                                    >
                                    <template v-slot:label>
                                        
                                    </template>  
                                    <v-radio
                                        label="Não"
                                        value="false"
                                        id="rdbDisab_N"
                                        @click="radioClick('disab_N')"
                                    ></v-radio>                                     
                                    <v-radio
                                        label="Sim"
                                        value="true"
                                        id="rdbDisab_S"
                                        @click="radioClick('disab_S')"
                                    ></v-radio>
                                                                         
                                    </v-radio-group> 
                                    <div
                                        v-show="isTrueValue(citizen.hasDisability)"
                                    >
                                        <v-col cols="12" sm="12" md="12" lg="12">
                                            <v-btn color="secondary"
                                                elevation="0"
                                                large
                                                outlined
                                                rounded @click="openAddDisability">
                                            <v-icon small left>mdi-plus-box</v-icon>
                                            ADICIONAR</v-btn>
                                            
                                            <modalAddDisability ref="mdDisability" :dialog.sync="showModalDisability" />
                                        </v-col>
                                    </div>

                                    <div id="divListDisability" v-show="isTrueValue(citizen.hasDisability)" xs6>
                                        <v-data-table
                                        :headers="this.headersDisabilityTable"
                                        :items="citizen.disabilities"
                                        class="elevation-0"
                                        hide-default-footer
                                        v-show="citizen.disabilities != null && citizen.disabilities.length > 0"
                                        >
                                            <template v-slot:item.AfetaMobilidade="{ item }">
                                                {{ getTextAffectedMobility(item.AfetaMobilidade) }}
                                            </template>
                                            <template v-slot:item.actions="{ item }">
                                                <v-icon
                                                    small
                                                    @click="removeDisability(item.DeficienciaId)"
                                                >
                                                    mdi-close
                                                </v-icon>
                                            </template>
                                        </v-data-table>
                                        <v-chip v-show="(citizen.disabilities != null && citizen.disabilities.length < 1)"
                                            small 
                                            color="primary" 
                                            label
                                        >Nenhuma informação encontrada</v-chip>                           
                                    </div>       
                                </v-col>                           
                            </v-row>              
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                    <v-card outlined>
                        <v-card-title class="text-h5 font-weight-bold"> 
                            Acolhimento
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <div>Já esteve acolhido? *</div>
                                    <v-radio-group
                                    v-model="citizen.hasPreviousAttendance"
                                    mandatory
                                    row
                                    >
                                    <template v-slot:label>
                                        
                                    </template>
                                    <v-radio
                                        label="Não Informado"
                                        value="ni"
                                        id="rdbPrevAtt_X"
                                        @click="radioClick('prevAtt_X')"
                                    ></v-radio>                                         
                                    <v-radio
                                        label="Sim"
                                        value="true"
                                        id="rdbPrevAtt_S"
                                        @click="radioClick('prevAtt_S')"
                                    ></v-radio>
                                    <v-radio
                                        label="Não"
                                        value="false"
                                        id="rdbPrevAtt_N"
                                        @click="radioClick('prevAtt_N')"
                                    ></v-radio>                                       
                                    </v-radio-group>
                                    
                                    <v-textarea
                                        v-show="!isPrevAttDisabled"
                                        outlined
                                        no-resize
                                        clearable
                                        v-model="citizen.previousAttendanceDescription"
                                        label="Em quais serviços *"
                                        maxLength="500"
                                        rows="2"
                                        rows-height="3"
                                        :counter="500"
                                    />                                                                 
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <div>Possui familiar(es) acolhido(s)? *</div>
                                    <v-radio-group
                                    v-model="citizen.hasFamilyAttended"
                                    mandatory
                                    row
                                    >
                                    <template v-slot:label>
                                        
                                    </template>
                                    <v-radio
                                        label="Não Informado"
                                        value="ni"
                                        @click="radioClick('att_X')"
                                    ></v-radio>                                         
                                    <v-radio
                                        label="Sim"
                                        value="true"
                                        @click="radioClick('att_S')"
                                    ></v-radio>
                                    <v-radio
                                        label="Não"
                                        value="false"
                                        @click="radioClick('att_N')"
                                    ></v-radio>                                       
                                    </v-radio-group> 
                                </v-col>
                                <v-col cols="12" sm="12" md="12" v-show="!isAttFamDisabled">
                                    <v-textarea
                                        outlined
                                        no-resize
                                        clearable
                                        v-model="citizen.familyAttendedDescription"
                                        label="Em quais serviços *"
                                        maxLength="500"
                                        rows="2"
                                        rows-height="3"
                                        :counter="500"
                                        
                                    />                                    
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <div>Vítima de violência? *</div>
                                    <v-radio-group
                                        v-model="citizen.isVictimViolence"
                                        mandatory
                                        row
                                        >
                                        <template v-slot:label>
                                            
                                        </template>
                                        <v-radio
                                            label="Não Informado"
                                            value="ni"
                                            @click="radioClick('vln_X')"
                                        ></v-radio>                                         
                                        <v-radio
                                            label="Sim"
                                            value="1"
                                            @click="radioClick('vln_S')"
                                        ></v-radio>
                                        <v-radio
                                            label="Não"
                                            value="0"
                                            @click="radioClick('vln_N')"
                                        ></v-radio>                                       
                                        </v-radio-group> 

                                        <div
                                            v-show="citizen.isVictimViolence == '1'"
                                        >
                                            <v-col cols="12" sm="12" md="12" lg="12">
                                                <v-btn color="secondary"
                                                    elevation="0"
                                                    large
                                                    outlined
                                                    rounded @click="openAddDistrictViolence">
                                                <v-icon small left>mdi-plus-box</v-icon>
                                                ADICIONAR</v-btn>
                                                
                                                <modalAddDistrictViolence ref="mdDistrictViolence" :dialog.sync="showModalDistrictViolence" />
                                            </v-col>
                                        </div> 
                                        <div v-show="citizen.isVictimViolence == '1'" dense xs6>
                                            
                                            <v-chip-group v-if="citizen.violencePlaceDistricts.length > 0"
                                                column 
                                                multiple
                                            >
                                                <v-chip 
                                                outlined
                                                label
                                                close
                                                close-icon="mdi-close"
                                                class="primary"
                                                v-for="(dst, index) in citizen.violencePlaceDistricts" 
                                                :key="'distViol_'+dst.DistritoId+'_'+index"
                                                @click:close="removeDistrictViolence(dst.DistritoId)">
                                                    {{ dst.DescricaoDistrito }}
                                                </v-chip>
                                            </v-chip-group>
                                            <v-chip v-else
                                                small 
                                                color="primary" 
                                                label
                                            >Nenhuma informação encontrada</v-chip>
                                                                          
                                        </div>                                        
                                    </v-col>
                                                                 
                            </v-row>
                                                        
                            <v-row>                                
                                <v-col cols="12" sm="12" md="12">
                                    <div>Está sob ameaça de morte? *</div>
                                    <v-radio-group
                                        v-model="citizen.isThreatened"
                                        mandatory
                                        row
                                        >
                                        <template v-slot:label>
                                            
                                        </template>
                                        <v-radio
                                            label="Não Informado"
                                            value="ni"
                                            @click="radioClick('thr_X')"
                                        ></v-radio>                                         
                                        <v-radio
                                            label="Sim"
                                            value="true"
                                            @click="radioClick('thr_S')"
                                        ></v-radio>
                                        <v-radio
                                            label="Não"
                                            value="false"
                                            @click="radioClick('thr_N')"
                                        ></v-radio>                                       
                                        </v-radio-group>  
                                        <div
                                            v-show="citizen.isThreatened == 'true'"
                                        >
                                            <v-col cols="12" sm="12" md="12" lg="12">
                                                <v-btn color="secondary"
                                                    elevation="0"
                                                    large
                                                    outlined
                                                    rounded @click="openAddDistrictThreat">
                                                <v-icon small left>mdi-plus-box</v-icon>
                                                ADICIONAR</v-btn>
                                                
                                                <modalAddDistrictThreat ref="mdDistrictThreat" :dialog.sync="showModalDistrictThreat" />
                                            </v-col>
                                        </div>   
                                        <div v-show="citizen.isThreatened == 'true'" dense xs6>
                                    
                                            <v-chip-group v-if="citizen.threatenedPlaceDistricts.length > 0"
                                                column 
                                                multiple
                                            >
                                                <v-chip 
                                                outlined
                                                label
                                                close
                                                close-icon="mdi-close"
                                                class="primary"
                                                v-for="(dst, index) in citizen.threatenedPlaceDistricts" 
                                                :key="'distCit_'+dst.DistritoId+'_'+index"
                                                @click:close="removeDistrictThreat(dst.DistritoId)">
                                                    {{ dst.DescricaoDistrito }}
                                                </v-chip>
                                            </v-chip-group>
                                            <v-chip v-else
                                                small 
                                                color="primary" 
                                                label
                                            >Nenhuma informação encontrada</v-chip>
                                                                    
                                        </div>                                   
                                    </v-col>
                                                                
                                </v-row>
                           
                            <v-row v-if="this.isTrueValue(citizen.isThreatened) && (currentAge < 22)">                                
                                <v-col cols="12" sm="12" md="12">
                                    <div>PPCAAM foi acionado? *</div>
                                    <v-radio-group
                                        v-model="citizen.isPPCAAM"
                                        mandatory
                                        row
                                        >
                                        <template v-slot:label>
                                            
                                        </template>
                                        <v-radio
                                            label="Não Informado"
                                            value="ni"
                                        ></v-radio>                                         
                                        <v-radio
                                            label="Sim"
                                            value="true"
                                        ></v-radio>
                                        <v-radio
                                            label="Não"
                                            value="false"
                                        ></v-radio>                                       
                                        </v-radio-group>                                        
                                </v-col>
                            </v-row>            
                             <v-row v-if="(this.isTrueValue(citizen.isThreatened)) ||(this.isTrueValue(citizen.isVictimViolence))">
                                <v-col cols="12" sm="12" md="12">
                                    <div>Acolhimento sigiloso? *</div>
                                    <v-radio-group
                                        v-model="citizen.isConfidencial"
                                        mandatory
                                        row
                                        
                                        >
                                        <template v-slot:label>
                                            
                                        </template>
                                        <v-radio
                                            label="Não informado"
                                            value="ni"
                                            @click="radioClick('atCnf_X')"
                                        ></v-radio>
                                        <v-radio
                                            label="Sim"
                                            value="1"
                                            @click="radioClick('atCnf_S')"
                                        ></v-radio>
                                        <v-radio
                                            label="Não"
                                            value="0"
                                            @click="radioClick('atCnf_N')"
                                        ></v-radio>                                       
                                    </v-radio-group>  
                                
                                    <v-select
                                        clearable
                                        item-value="ID"
                                        item-text="Descricao"
                                        :items="listTipologiaServicoAcolhimentoSigiloso"
                                        v-model="citizen.idServiceTypeSecretAttendence"
                                        label="Em qual tipologia? *"
                                        outlined
                                        v-if="citizen.isConfidencial == '1'"
                                        
                                    />                                    
                                </v-col>
                            </v-row>
                        </v-card-text>                                                                                                                                                                                                                                                                                                                                                                                              
                    </v-card>
                </v-col>

                 <v-col cols="12" sm="12" md="12" v-if="((currentAge > 0 && currentAge < 18) || (currentAge >= 14 && currentAge <= 21))">
                    <v-card outlined>
                        <v-card-title class="text-h5 font-weight-bold"> 
                            Processos
                        </v-card-title>

                        <v-card-text>
                            <v-row v-if="(currentAge > 0 && currentAge < 18)">
                                <v-col cols="12" sm="12" md="12">
                                    <div>Há processo na Vara da Infância e Juventude? *</div>
                                    <v-radio-group v-model="citizen.hasLawsuitVIJ" mandatory row >
                                        <template v-slot:label>
                                            
                                        </template>
                                        <v-radio label="Não Informado" value="ni" @click="radioClick('vij_X')"></v-radio>
                                        <v-radio label="Sim" value="true" @click="radioClick('vij_S')"></v-radio>
                                        <v-radio label="Não" value="false" @click="radioClick('vij_N')"></v-radio>
                                    </v-radio-group>

                                    <div v-if="citizen.hasLawsuitVIJ == 'true'">
                                        <v-select
                                            clearable
                                            :rules="[rules.required]"
                                            item-value="value"
                                            item-text="text"
                                            :items="listVIJ"
                                            v-model="citizen.lawsuitVIJ"
                                            label="Em qual vara? *"
                                            outlined
                                        />
                                    </div>
                                    <div v-if="citizen.hasLawsuitVIJ == 'true'">
                                        <v-text-field-custom
                                            maxLength="25"
                                            v-model="citizen.lawsuitVIJNumber"
                                            label="Número do processo"
                                            v-bind:properties="{
                                                readonly: false,
                                                disabled: false,
                                                outlined: true,
                                                clearable: true,
                                                placeholder: '',
                                            }"
                                            v-bind:options="{
                                                humanMask: '#######-##.####.#.##.####',
                                                machineMask: '#######-##.####.#.##.####',
                                                empty: null,
                                                applyAfter: false,
                                                alphanumeric: false,
                                                lowerCase: false,
                                            }"
                                        ></v-text-field-custom>                                  
                                    </div> 
                                </v-col>
                                                               
                            </v-row>
                            <v-row v-if="(currentAge >= 14 && currentAge <= 21)">
                                <v-col cols="12" sm="12" md="12">
                                    <div>Há processo no DEIJ? *</div>
                                    <v-radio-group v-model="citizen.hasLawsuitDEIJ" mandatory row >
                                        <template v-slot:label>
                                            
                                        </template>
                                        <v-radio label="Não Informado" value="ni" @click="radioClick('dei_X')"></v-radio>
                                        <v-radio label="Sim" value="true" @click="radioClick('dei_S')"></v-radio>
                                        <v-radio label="Não" value="false" @click="radioClick('dei_N')"></v-radio>
                                    </v-radio-group>

                                    <div v-if="citizen.hasLawsuitDEIJ == 'true'">
                                        <v-text-field-custom
                                            maxLength="25"
                                            v-model="citizen.lawsuitNumberDEIJ"
                                            label="Número do processo"
                                            v-bind:properties="{
                                                readonly: false,
                                                disabled: false,
                                                outlined: true,
                                                clearable: true,
                                                placeholder: '',
                                            }"
                                            v-bind:options="{
                                                humanMask: '#######-##.####.#.##.####',
                                                machineMask: '#######-##.####.#.##.####',
                                                empty: null,
                                                applyAfter: false,
                                                alphanumeric: false,
                                                lowerCase: false,
                                            }"
                                        ></v-text-field-custom>                                  
                                    </div> 
                                    <div>
                                        <v-radio-group v-model="citizen.hasCourtOrdered" mandatory row >
                                            <template v-slot:label>
                                                <div>Possui Ordem Judicial? *</div>
                                            </template>
                                            <v-radio label="Não Informado" value="ni" @click="radioClick('cor_X')"></v-radio>
                                            <v-radio label="Sim" value="true" @click="radioClick('cor_S')"></v-radio>
                                            <v-radio label="Não" value="false" @click="radioClick('cor_N')"></v-radio>
                                        </v-radio-group>
                                    </div>                            
                                    <div v-if="citizen.hasCourtOrdered == 'true'">
                                        <v-textarea 
                                            outlined 
                                            no-resize 
                                            clearable 
                                            v-model="citizen.courtOrderedDescription"
                                            label="Determinação Judicial *" 
                                            maxLength="500" 
                                            rows="2" 
                                            rows-height="3" 
                                            :counter="500"
                                        />                                        
                                    </div>  
                                </v-col>                          
                            </v-row>                            
                        </v-card-text>
                    </v-card>
                 </v-col>

                 <v-col  cols="12" sm="12" md="12">
                    <v-card outlined>
                        <v-card-title class="text-h5 font-weight-bold"> 
                            Saúde
                        </v-card-title>

                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <div>Utiliza medicações de uso contínuo? *</div>
                                    <v-radio-group v-model="citizen.hasContinuosMedicament" mandatory row>
                                        <template v-slot:label>
                                            
                                        </template>
                                        <v-radio label="Não Informado" value="ni" @click="radioClick('med_X')"></v-radio>
                                        <v-radio label="Sim" value="true" @click="radioClick('med_S')"></v-radio>
                                        <v-radio label="Não" value="false" @click="radioClick('med_N')"></v-radio>
                                    </v-radio-group>
                                    <div v-show="citizen.hasContinuosMedicament == 'true'">
                                        <v-textarea dense outlined no-resize clearable v-model="citizen.continuosMedicamentDescription"
                                            label="Quais medicamentos? *" maxLength="500" rows="2" rows-height="3" :counter="500"/>
                                    </div>
                                </v-col>

                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <div>Realiza acompanhamento em serviço de saúde? *</div>
                                    <v-radio-group v-model="citizen.hasHealthMonitoring" mandatory row>
                                        <template v-slot:label>
                                            
                                        </template>
                                        <v-radio label="Não Informado" value="ni" @click="radioClick('hmon_X')"></v-radio>
                                        <v-radio label="Sim" value="true" @click="radioClick('hmon_S')"></v-radio>
                                        <v-radio label="Não" value="false" @click="radioClick('hmon_N')"></v-radio>
                                    </v-radio-group>

                                    <div cols="12" sm="12" v-show="citizen.hasHealthMonitoring == 'true'">
                                        <v-textarea outlined no-resize clearable v-model="citizen.healthMonitoringPlace"
                                            label="Em qual unidade de saúde? *" maxLength="500" rows="2" rows-height="3" :counter="500"/>
                                    </div>
                                    
                                </v-col>
                                
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <div>Realiza acompanhamento no CAPS?</div>
                                    <v-radio-group
                                        v-model="citizen.hasAttendenceCAPS"
                                        mandatory
                                        row
                                        >
                                            <template v-slot:label>
                                                
                                            </template>
                                            <v-radio label="Não Informado" value="ni" @click="radioClick('atCaps_X')"></v-radio>                                         
                                            <v-radio label="Sim" value="true" @click="radioClick('atCaps_S')"></v-radio>
                                            <v-radio label="Não" value="false" @click="radioClick('atCaps_N')"></v-radio>                                       
                                        </v-radio-group> 
                                    <div cols="12" sm="12" v-if="citizen.hasAttendenceCAPS == 'true'">
                                        <v-textarea outlined no-resize clearable v-model="citizen.attendenceCAPSDescription"
                                            label="Em qual CAPS? *" maxLength="500" rows="2" rows-height="3" :counter="500"/>
                                    </div>
                                </v-col>
                                
                            </v-row>
                        </v-card-text>
                    </v-card>
                 </v-col>

                 <v-col cols="12" sm="12" md="12">
                    <v-card outlined>
                        <v-card-title class="text-h5 font-weight-bold"> 
                            Informações adicionais
                        </v-card-title>

                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    
                                    <v-radio-group
                                        v-model="citizen.hasFinancialAutonomy"
                                        mandatory
                                        row
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    <v-tooltip top color="blue">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon
                                                            color="blue"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            mdi-information-outline
                                                            </v-icon>
                                                        </template>
                                                        <span>O preenchimento desse campo é indicado para acolhimento em República para Jovens, República para Adultos e Autonomia em Foco </span>
                                                    </v-tooltip>
                                                    Possui autonomia financeira?
                                                </div>
                                            </template>
                                            <v-radio
                                                label="Não Informado"
                                                value="ni"
                                            ></v-radio>                                         
                                            <v-radio
                                                label="Sim"
                                                value="true"
                                            ></v-radio>
                                            <v-radio
                                                label="Não"
                                                value="false"
                                            ></v-radio>                                       
                                        </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-radio-group
                                        v-model="citizen.hasCart"
                                        mandatory
                                        row
                                        >
                                            <template v-slot:label>
                                                <div>
                                                    <v-tooltip top color="blue">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon
                                                            color="blue"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            mdi-information-outline
                                                            </v-icon>
                                                        </template>
                                                        <span>O preenchimento desse campo indicado para acolhimento em CA Catadores </span>
                                                    </v-tooltip>
                                                    Possui carroça?</div>
                                            </template>
                                            <v-radio
                                                label="Não Informado"
                                                value="ni"
                                            ></v-radio>                                         
                                            <v-radio
                                                label="Sim"
                                                value="true"
                                            ></v-radio>
                                            <v-radio
                                                label="Não"
                                                value="false"
                                            ></v-radio>                                       
                                        </v-radio-group>  
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-radio-group v-model="citizen.hasPet" mandatory row>
                                        <template v-slot:label>
                                            <div>
                                                <v-tooltip top color="blue">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-icon
                                                            color="blue"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            mdi-information-outline
                                                            </v-icon>
                                                        </template>
                                                        <span>O preenchimento desse campo indicado para acolhimento em CA Catadores</span>
                                                    </v-tooltip>
                                                Possui animal de estimação?</div>
                                        </template>
                                        <v-radio label="Não Informado" value="ni"></v-radio>
                                        <v-radio label="Sim" value="true"></v-radio>
                                        <v-radio label="Não" value="false"></v-radio>
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                            <v-row v-if="this.getEnabledConvalescence">                                
                                <v-col cols="12" sm="12" md="8">
                                    <v-radio-group
                                        v-model="citizen.isConvalescence"
                                        mandatory
                                        row
                                        >
                                        <template v-slot:label>
                                            <div>
                                                <v-tooltip top color="blue">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                        color="blue"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        >
                                                        mdi-information-outline
                                                        </v-icon> 
                                                    </template>
                                                    <span>O preenchimento desse campo é indicado para acolhimento em CAE CONVALESCENTES</span>                                                       
                                                </v-tooltip>
                                                Está em período de convalescência? *
                                            </div>
                                        </template>
                                        <v-radio label="Não Informado" value="ni" @click="radioClick('conva_X')"></v-radio>                                         
                                        <v-radio label="Sim" value="true" @click="radioClick('conva_S')"></v-radio>
                                        <v-radio label="Não" value="false" @click="radioClick('conva_N')"></v-radio>                                       
                                    </v-radio-group>                                        
                                </v-col>
                                <v-col cols="12" sm="12" v-show="citizen.isConvalescence == 'true'">
                                    <v-textarea
                                        outlined
                                        no-resize
                                        clearable
                                        v-model="citizen.prognosisDescription"
                                        label="Prognósticos *"
                                        maxLength="500"
                                        rows="2"
                                        rows-height="3"
                                        :counter="500"
                                        
                                    />
                                </v-col>
                            </v-row>                                                     
                        </v-card-text>
                    </v-card>
                 </v-col>

                <v-col  cols="12" sm="12" md="12">
                    <v-card elevation="0">
                        <v-card-text>
                            <v-row class="d-flex justify-start">
                                
                                    <v-btn
                                        color="primary"
                                        large
                                        outlined
                                        rounded
                                        @click="close"
                                        elevation="0">
                                            Cancelar</v-btn>
                                
                                    <v-btn 
                                        class="ml-4"
                                        color="primary"
                                        large
                                        rounded
                                        elevation="0"
                                        @click="add"
                                    >
                                    Salvar</v-btn>
                                
                            </v-row>
                                        
                            
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-form>
        <snackbar
            :text="snackbarMessage"
            :color="snackbarColor"
        />
            <v-dialog
             v-model="dialogCitizenOk"
             width="500">
                <v-card>
                    <v-card-title class="light-blue darken-4 white--text">
                        {{titleModalCitizen}}
                    </v-card-title>
                    <v-card-text>
                        <br/>
                        {{msgModalCitizen}}
                        <br/>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                                <v-btn 
                                    color="primary"
                                    elevation="0"
                                    large
                                    outlined
                                    rounded
                                    @click="dialogCitizenOk=false">
                                <v-icon left>mdi-check</v-icon>OK
                                </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

       <v-dialog
            v-model="dialogCitizenError"
            width="500"
        >
            <v-card>
                <v-card-title class="light-blue darken-4 white--text">
                Atenção
                </v-card-title>

                <v-card-text>
                <br/>
                <p>Não foi possível efetuar a inclusão do cidadão.</p>
                <div class="text--primary espaco-top" v-html="returnedCitizenErrorMessage"></div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    large
                    outlined
                    rounded
                    elevation="0"
                    @click="dialogCitizenError = false"
                >
                    CONFIRMAR
                </v-btn>
                </v-card-actions>
            </v-card>    
        </v-dialog>         
        </v-card>
    </v-dialog>
</template>
<script>
import snackbarMixin from "../../mixins/snackbar.mixin";
import moment from 'moment';
import Cpf from '../../components/masked/cpf.vue';
import Processo from '../../components/masked/simple-mask.vue';
import AddDisability from './AddDisability.vue';
import AddThirdpartyCare from './AddThirdpartyCare.vue';
import AddDistrictThreat from './AddDistrictThreat.vue';
import { mapGetters } from 'vuex';

export default {
    props:{
        dialog:{
            default:false
        }
    },
    mixins: [snackbarMixin],
    components: {
        "v-text-field-cpf": Cpf,
        "modalAddDisability": AddDisability,
        "modalAddThirdPartyCare": AddThirdpartyCare,
        "modalAddDistrictThreat": AddDistrictThreat,
        "modalAddDistrictViolence": AddDistrictThreat,
        "v-text-field-custom": Processo,        
    },
    data(){
        return {
            certidaoNova: false,
            dialogCitizenError: false,
            dialogCitizenOk:false,
            titleModalCitizen:'',
            msgModalCitizen:'',
            returnedCitizenErrorMessage: '',
            citizen: {
                idTypeForm: null,                
                idGrid: 0,
                id: '',
                isPrincipal: false,
                principalCitizenRelationship: '',
                citizenSISA: '',
                hasFinancialAutonomy: 'ni',
                name: '',
                socialName: '',
                motherName: '',
                birthDate: '',
                age: '',
                idGender: '',
                idGenderIdentity: '',
                idRace: '',
                idMaritalStatus: '',
                idDependencyDegree: '',
                DocumentoIdentidade: {
                    number: '',
                    digit: '',
                    issuer: '',
                    stateAcronym: '',
                    issueDate: '',
                },
                cpf: '',
                certidaoNascimentoType: '',
                CertidaoNascimento: {
                    number: '',
                    book: '',
                    page: '',
                    idCity: '',
                    districtName: '',
                    stateAcronym: '',
                    numberNew: ''
                },
                nationality: '',
                DocumentoIdentidadeEstrangeiro: {
                    number: '',
                    immigrationDate: '',
                    naturalizationDate: '',
                    idOriginCountry: '',
                    ordinanceNaturalization: '',
                    passport: ''
                },
                hasDisability: '',
                isMobilityAffected: '',
                isAcessibleSpace: '',
                acessibleSpaceDescription: '',
                prognosisDescription: '',
                hasAssistiveTechnology: '',
                hasThirdpartyCare: '',
                isPregnant: '',
                hasFamilyAttended: 'ni',
                familyAttendedDescription: '',
                isConfidencial: '2',
                isVictimViolence: 'ni',
                hasPreviousAttendance: 'ni',
                previousAttendanceDescription: '',
                isThreatened: 'ni',
                threatenedPlaceDistricts: [],
                violencePlaceDistricts: [],
                threatenedPlaceDescription: '',
                isPPCAAM: 'ni',
                isConvalescence: 'ni',
                hasLawsuitVIJ: 'ni',
                lawsuitVIJNumber: '',
                lawsuitVIJ: '',
                hasLawsuitDEIJ: '',
                lawsuitNumberDEIJ: '',
                hasCourtOrdered: 'ni',
                courtOrderedDescription: '',
                hasContinuosMedicament: 'ni',
                continuosMedicamentDescription: '',
                hasAttendenceCAPS: 'ni',
                attendenceCAPSDescription: '',
                hasCart: 'ni',
                hasHealthMonitoring: 'ni',
                healthMonitoringPlace: '',
                hasPet: 'ni',
                disabilities: [],
                careTypes: [],
                idServiceTypeSecretAttendence: [],
            },
            validCitizen:true,
            listDistrict: [],
            listAllDistrict: [],
            listState: [{"nome": "AC - Acre", "sigla": "AC"},{"nome": "AL - Alagoas", "sigla": "AL"},{"nome": "AP - Amapá", "sigla": "AP"},{"nome": "AM - Amazonas", "sigla": "AM"},{"nome": "BA - Bahia", "sigla": "BA"},{"nome": "CE - Ceará", "sigla": "CE"},{"nome": "DF - Distrito Federal", "sigla": "DF"},{"nome": "ES - Espírito Santo", "sigla": "ES"},{"nome": "GO - Goiás", "sigla": "GO"},{"nome": "MA - Maranhão", "sigla": "MA"},{"nome": "MT - Mato Grosso", "sigla": "MT"},{"nome": "MS - Mato Grosso do Sul", "sigla": "MS"},{"nome": "MG - Minas Gerais", "sigla": "MG"},{"nome": "PA - Pará", "sigla": "PA"},{"nome": "PB - Paraíba", "sigla": "PB"},{"nome": "PR - Paraná", "sigla": "PR"},{"nome": "PE - Pernambuco", "sigla": "PE"},{"nome": "PI - Piauí", "sigla": "PI"},{"nome": "RJ - Rio de Janeiro", "sigla": "RJ"},{"nome": "RN - Rio Grande do Norte", "sigla": "RN"},{"nome": "RS - Rio Grande do Sul", "sigla": "RS"},{"nome": "RO - Rondônia", "sigla": "RO"},{"nome": "RR - Roraima", "sigla": "RR"},{"nome": "SC - Santa Catarina", "sigla": "SC"},{"nome": "SP - São Paulo", "sigla": "SP"},{"nome": "SE - Sergipe", "sigla": "SE"},{"nome": "TO - Tocantins", "sigla": "TO"}],
            listCityAddress: [],
            listCityCertidaoNascimento: [],
            listPaisFiltrada: [],
            isVijDisabled: true,
            ishMonDisabled: true,
            isMedDisabled: true,
            isAttFamDisabled: true,
            isPrevAttDisabled: true,
            isPrincpalRelDisabled: true,
            rules:{
                required: value =>  !!value || 'Campo obrigatório',
                serviceTypeSecretAttendenceRequired: value => (this.isTrueValue(this.citizen.idServiceTypeSecretAttendence) && !!value) || 'Campo obrigatório',
            },
            //listAdd:[],
            citizenUpdatable: '',
            rangeYearValid: '',
            listTypeForm: [ { 'value': 'FR-M', 'text': 'Formulário de reordenamento - Mulheres' }, { 'value': 'FS-M', 'text': 'Formulario solicitacao de vagas - Mulheres' }, { 'value': 'FR-0-21', 'text': 'Formulário  de reordenamento - 0 a 21 anos' }, { 'value': 'FS-0-21', 'text': 'Formulario solicitacao de vagas - 0 a 21 anos' }, { 'value': 'FS-CAE/CV', 'text': 'Formulario solicitacao de vaga - CAE Convalescente' }, { 'value': 'FS-FAC', 'text': 'Formulario solicitacao de vagas - Família_Autonomia_Catadores' }, { 'value': 'FS-RI', 'text': 'Formulario solicitacao de vagas - RI' }],
            showFormPrgnt: false,
            showGrpForeign: false,
            currentAge: -1,
            showModalDisability: false,
            showModalThirdPartyCare: false,
            showModalDistrictThreat: false,
            showModalDistrictViolence: false,
            headersDisabilityTable: [
                { text: 'Descrição', value: 'DescricaoDefiencia', sortable: false },
                { text: 'Afeta Mobilidade', value: 'AfetaMobilidade', sortable: false },
                { text: 'Excluir', value: 'actions', sortable: false },
            ]
        }
    },
    methods:{
        close(){
            this.clearFields();
            this.citizenUpdatable = '';
            this.$emit('update:dialog', false)
        },
        setCitizenUpdate(value){
            this.citizenUpdatable = this.toCitizenModelView(value);
            if(this.citizenUpdatable != null && this.citizenUpdatable != ''){
                this.citizen = this.citizenUpdatable;
                this.manageGroupForeing(this.citizenUpdatable.nationality);
                this.getPresentAge(this.citizen.birthDate);
            }
            this.initDisabledForm();
        },
        validateCpf(cpf) {
            cpf = cpf.replace(/[^\d]+/g, "");
            if (cpf == "") return false;
            // Eliminar CPFs invalidos conhecidos
            if (
                cpf.length != 11 ||
                cpf == "00000000000" ||
                cpf == "11111111111" ||
                cpf == "22222222222" ||
                cpf == "33333333333" ||
                cpf == "44444444444" ||
                cpf == "55555555555" ||
                cpf == "66666666666" ||
                cpf == "77777777777" ||
                cpf == "88888888888" ||
                cpf == "99999999999"
            )
                return false;
            // Validar 1o digito
            let add = 0;
            for (var i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
            rev = 11 - (add % 11);
            if (rev == 10 || rev == 11) rev = 0;
            if (rev != parseInt(cpf.charAt(9))) return false;
            // Validar 2o digito
            add = 0;
            for (var j = 0; j < 10; j++) add += parseInt(cpf.charAt(j)) * (11 - j);
            let rev = 11 - (add % 11);
            if (rev == 10 || rev == 11) rev = 0;
            if (rev != parseInt(cpf.charAt(10))) return false;
            return true;
        },        
        add(){
            let retorno = this.formValidate();

            if(retorno.status && this.$refs.formCitizen.validate()){
                if(this.citizenUpdatable != null && this.citizenUpdatable != '')
                {
                    this.citizen.idGrid = this.citizenUpdatable.idGrid;
                    let tagFind = this.$parent.$parent.listCitizen.map(e=>e.idGrid).indexOf(this.citizenUpdatable.idGrid);
                    //remove o item do array
                    this.$parent.$parent.listCitizen.splice(tagFind, 1);
                    this.citizenUpdatable = '';  
                }else{
                    this.citizen.idGrid = this.getMaxIdGrid();
                }                     

                this.$parent.$parent.listCitizen.push(this.toCitizenModelAPI());
                this.$parent.$parent.listCitizen = this.$parent.$parent.listCitizen.sort((a,b) => (a.idGrid > b.idGrid) ? 1 : ((b.idGrid > a.idGrid) ? -1 : 0));
                console.log(this.$parent.$parent.listCitizen);
                this.clearFields();

                if(this.$parent.$parent.tipoPerfilSolicitacao == "I" && this.$parent.$parent.listCitizen.length == 1){
                    this.titleModalCitizen="Inclusão de Cidadão";
                    this.msgModalCitizen="Cidadão adicionado com sucesso. Nâo é possível adicionar mais cidadãos para o perfil individual.";
                    this.dialogCitizenOk=true;
                    this.close();
                } 
                else if(this.$parent.$parent.tipoPerfilSolicitacao == "C" && this.$parent.$parent.listCitizen.length == 2){
                    this.titleModalCitizen="Inclusão de Cidadão";
                    this.msgModalCitizen="Cidadão adicionado com sucesso. Nâo é possível adicionar mais cidadãos para o perfil casal.";
                    this.dialogCitizenOk=true;
                    this.close();
                }
                else {
                    this.titleModalCitizen="Inclusão de Cidadão";
                    this.msgModalCitizen="Cidadão adicionado com sucesso.";
                    this.dialogCitizenOk=true;
                }

                this.$refs.formCitizen.$el.txCitizenName.focus();
           } else if(!retorno.status){
               this.returnedCitizenErrorMessage = '<ul><li>' + retorno.message.join('</li><li>') + '</ul>';
               this.dialogCitizenError = true;
               this.$refs.formCitizen.$el.txCitizenName.focus();
           }
        },
        getMaxIdGrid()
        {
            let maxGridId = Math.max.apply(Math, this.$parent.$parent.listCitizen.map(e=> e.idGrid));
            if(maxGridId < 1)
                maxGridId = 1;
            else
                maxGridId++;
            
            return maxGridId;
        },
        toCitizenModelView(item)
        {
            if(item == null || item == '')
                return null;

            let cidadaoView = {
                idTypeForm: item.idTipoFormulario,
                idGrid: item.idGrid,
				id: item.codigoSolicitacao,
				isPrincipal: item.indicadorCidadãoPrincipal,
				principalCitizenRelationship: item.parentescoCidadaoPrincipal,
				citizenSISA: item.codigoCidadaoSISA,
				hasFinancialAutonomy: this.trataValorNaoInformadoModelView(item.possuiAutonomiaFinanceira),
				name: item.nome,
				socialName: item.nomeSocial,
				motherName: item.nomeMae,
				birthDate: item.dataNascimento,
				idGender: item.codigoTipoSexo,
				idGenderIdentity: item.codigoIdentidadeSexual,
				idRace: item.codigoRaca,
				idMaritalStatus: item.codigoEstadoCivil,
                idDependencyDegree: item.codigoGrauDependencia,
				DocumentoIdentidade: this.toDocumentoIdentidadeModelView(item.documentoIdentidade),
				cpf: item.numeroCPF,
                certidaoNascimentoType: item.tipoCertidao,
				CertidaoNascimento: this.toCertidaoNascimentoModelView(item.certidaoNascimento),
				nationality: (item.tipoNacionalidade == null || item.tipoNacionalidade == '') ? '-1' : item.tipoNacionalidade,
				DocumentoIdentidadeEstrangeiro: this.toDocumentoIdentidadeEstrangeiroModelView(item.documentoIdentidadeEstrangeiro),
				hasDisability: item.indicadorPossuiDeficiencia,
				prognosisDescription: item.descricaoPrognostico,
				hasAssistiveTechnology: item.indicadorTecnologiaAssistiva,
				hasThirdpartyCare: item.indicadorCuidadoTerceiros,
				isPregnant: item.indicadorGestante,
				hasFamilyAttended: this.trataValorNaoInformadoModelView(item.indicadorPossuiFamiliarAcolhido),
				familyAttendedDescription: item.descricaoFamiliarAcolhido,
				isConfidencial: this.trataValorNaoInformadoModelView(item.indicadorAcolhimentoSigiloso),
				isVictimViolence: (item.indicadorVitimaViolencia == '1' || item.indicadorVitimaViolencia == '2') ? item.indicadorVitimaViolencia : 'ni',
				hasPreviousAttendance: this.trataValorNaoInformadoModelView(item.indicadorAcolhimentoAnterior),
				previousAttendanceDescription: item.descricaoLocalAcolhimentoAnterior,
				isThreatened:  this.trataValorNaoInformadoModelView(item.indicadorAmeaca),
				threatenedPlaceDescription: item.descricaoLocalEncontraAmeacado,
                threatenedPlaceDistricts: this.toDistritoAmeacaModelView(item.distritos, 'A'),
                violencePlaceDistricts: this.toDistritoAmeacaModelView(item.distritos, 'V'),
                isPPCAAM: item.indicadorPPCAAM,
                isConvalescence: item.indicadorConvalescencia,
				hasLawsuitVIJ: this.trataValorNaoInformadoModelView(item.indicadorProcessoVIJ),
				lawsuitVIJNumber: item.descricaoProcessoVIJ,
                lawsuitVIJ: item.codigoVaraInfancia,
                hasLawsuitDEIJ: this.trataValorNaoInformadoModelView(item.indicadorProcessoDEIJ),
                lawsuitNumberDEIJ: item.descricaoProcessoDEIJ,
                hasCourtOrdered: this.trataValorNaoInformadoModelView(item.indicadorOrdemJudicial),
                courtOrderedDescription: item.descricaoOrdemJudicial,
				hasContinuosMedicament: this.trataValorNaoInformadoModelView(item.indicadorMedicacaoContinua),
				continuosMedicamentDescription: item.descricaoMedicacaoContinua,
				hasAttendenceCAPS: this.trataValorNaoInformadoModelView(item.indicadorAcompanhamentoCAPS),
                attendenceCAPSDescription: item.descricaoAcompanhamentoCAPS,
				hasCart: this.trataValorNaoInformadoModelView(item.indicadorPossuiCarroca),
				hasHealthMonitoring: this.trataValorNaoInformadoModelView(item.indicadorFazAcompanhamentoServicoSaude),
                healthMonitoringPlace: item.descricaoAcompanhamentoServicoSaude,
				hasPet: this.trataValorNaoInformadoModelView(item.indicadorPossuiAnimalEstimacao),
				address: this.toEnderecoModelView(item.enderecoCidadao),
				disabilities: this.toDeficienciaModelView(item.deficiencias),
				careTypes: this.toFormaCuidadeModelView(item.formasCuidado),
                isMobilityAffected: item.indicadorMobilidadeAfetada,
                idServiceTypeSecretAttendence: this.toTiposServicosSolicitadosModelView(item.tiposServicosSolicitados),
                isAcessibleSpace: item.indicadorVagaAcessivel,
                acessibleSpaceDescription: item.descricaoVagaAcessivel,
			}
            this.certidaoNova = (item.tipoCertidao == 'N');

            return cidadaoView;
        },
        trataValorNaoInformadoModelView(value){
            if(value == null || value == ''){
                return 'ni'
            }else{
                return value;
            }
        },
        toDistritoAmeacaModelView(value, type){
            let lstDistritos = [];
            let arrDistritos = [];
            arrDistritos = value.filter(d => d.tipoUso == type);



            if(arrDistritos != null && arrDistritos.length > 0){
                for (let i = 0; i < arrDistritos.length; i++) {
                    let distritoAdd = { "DistritoId": arrDistritos[i].codigo, 'DescricaoDistrito': arrDistritos[i].descricao, 'tipoUso': arrDistritos[i].tipoUso };
                    lstDistritos.push(distritoAdd);
                }
            }

            return lstDistritos;
        },
        toTiposServicosSolicitadosModelView(value){
            let idServico = '';

            if(value != null && value.length > 0)
                idServico = value[0];

            return idServico;
        },
        toFormaCuidadeModelView(formas){
            let lstFormas = [];

            if(formas != null && formas.length > 0){
                for (let i = 0; i < formas.length; i++) {
                    let formaFind = this.listFormasCuidado.find(f => parseInt(f.FormaCuidadoId) == formas[i]);
                    if(formaFind != null)
                        lstFormas.push(formaFind);
                }
            }

            return lstFormas;
        },
        toDeficienciaModelView(deficiencias){
            let arrDeficiencias = [];
            let disabFind = '';
            for(let i=0;i < deficiencias.length;i++){
                disabFind = this.listDeficiencia.find(d => d.DeficienciaId == deficiencias[i].codigo);
                if(disabFind != null && disabFind.DeficienciaId != null)
                    arrDeficiencias.push({ 'DeficienciaId': disabFind.DeficienciaId, 'afetaMobilidade': (disabFind.AfetaMobilidade == 1) ? true : false, 'DescricaoDefiencia': disabFind.DescricaoDefiencia });

                disabFind = '';
            }

            return arrDeficiencias;
        },
        toDocumentoIdentidadeModelView(item){
            let docID = {
                number: '',
                digit: '',
                issuer: '',
                stateAcronym: '',
                issueDate: '',
            };

            if(item != null){
                docID.number =  item.numero;
                docID.digit = item.digito;
                docID.issuer = item.orgaoEmissor;
                docID.stateAcronym = item.uf;
                docID.issueDate = item.dataEmissao;
            } 

            return docID;
        },
        toDocumentoIdentidadeEstrangeiroModelView(item){
            let docIdFor = {
                number: '',
                immigrationDate: '',
                naturalizationDate: '',
                idOriginCountry: '',
                ordinanceNaturalization: '',
                passport: '',
            }
            if(item != null){
                    docIdFor.number = item.numeroRNE;
                    docIdFor.immigrationDate = item.dataEntradaPais;
                    docIdFor.naturalizationDate = item.dataNaturalizacao;
                    docIdFor.idOriginCountry = item.codigoPaisOrigem;
                    docIdFor.ordinanceNaturalization = item.numeroPortariaNaturalizacao;
                    docIdFor.passport = item.numeroPassaporte;
            } 

            return docIdFor;

        },  
        toEnderecoModelView(item){
            let endereco = {
                idBorough: '',
                idStreetType: '',
                landmark: '',
                street: '',
                number: '',
                complement: '',
                neighborhood: '',
                zipcode: '',
                idDistrict: '',
                idCity: '',
            };            
            if(item != null){
                endereco.idBorough = !item.codigoSubprefeitura?'':item.codigoSubprefeitura,
                endereco.idStreetType = !item.codigoTipoLogradouro?'':item.codigoTipoLogradouro,
                endereco.landmark = !item.pontoReferencia?'':item.pontoReferencia,
                endereco.street = !item.nomeLogradouro?'':item.nomeLogradouro,
                endereco.number = !item.numeroLogradouro?'':item.numeroLogradouro,
                endereco.complement = !item.complemento?'':item.complemento,
                endereco.neighborhood = !item.nomeBairro?'':item.nomeBairro,
                endereco.zipcode = !item.cep?'':item.cep,
                endereco.idDistrict = !item.codigoDistrito?'':item.codigoDistrito,
                endereco.idCity = !item.codigoCidade?'':item.codigoCidade                 
            } 
            return endereco;            
        },
        toCertidaoNascimentoModelView(item){
            let certNasc = {
                number: '',
                book: '',
                page: '',
                idCity: '',
                districtName: '',
                stateAcronym: '',
                issueDate: '',
                registryName: '',
                numberNew: '',
            }
            if(item != null){
                    certNasc.number = item.numero,
                    certNasc.book = item.livro,
                    certNasc.page = item.folha,
                    certNasc.idCity = item.codigoCidade,
                    certNasc.districtName = item.nomeDistrito,
                    certNasc.issueDate = item.dataEmissao,
                    certNasc.registryName = item.nomeCartorio,
                    certNasc.stateAcronym = item.uf;
                    certNasc.numberNew = item.numeroNovo
            } 

            return certNasc;
        },                          
        toCitizenModelAPI(){
            let cidadaoModel =  {
                "idTipoFormulario": this.citizen.idTypeForm,
                "idGrid": this.citizen.idGrid,
                "codigoSolicitacao": this.citizen.id,
                "indicadorCidadãoPrincipal": true,
                "parentescoCidadaoPrincipal": "principal",
                "codigoCidadaoSISA": this.citizen.citizenSISA,
                "possuiAutonomiaFinanceira": this.trataNaoInformadoModelAPI(this.citizen.hasFinancialAutonomy),
                "nome": this.citizen.name ? this.citizen.name.toUpperCase() : "",
                "nomeSocial": this.citizen.socialName ? this.citizen.socialName.toUpperCase() : "",
                "nomeMae": this.citizen.motherName ? this.citizen.motherName.toUpperCase() : "",
                "dataNascimento": this.citizen.birthDate,
                "codigoTipoSexo": this.citizen.idGender,
                "codigoIdentidadeSexual": this.citizen.idGenderIdentity,
                "codigoRaca": this.citizen.idRace,
                "codigoEstadoCivil": this.citizen.idMaritalStatus,
                "codigoGrauDependencia": this.citizen.idDependencyDegree,
                "documentoIdentidade": this.toDocumentoIdentidadeModelAPI(),
                "numeroCPF": this.citizen.cpf,
                "tipoCertidao": this.isTrueValue(this.certidaoNova) ? 'N' : 'A',
                "certidaoNascimento": this.toCertidaoNascimentoModelAPI(),
                "tipoNacionalidade": (this.citizen.nationality == '-1') ? null : this.citizen.nationality,
                "documentoIdentidadeEstrangeiro": this.todocumentoIdentidadeEstrangeiroModelAPI(),
                "indicadorPossuiDeficiencia": this.convertToBoolean(this.citizen.hasDisability),
                "descricaoPrognostico": this.citizen.prognosisDescription,
                "indicadorTecnologiaAssistiva": this.citizen.hasAssistiveTechnology,
                "indicadorCuidadoTerceiros": (this.citizen.hasThirdpartyCare == '')?null:this.citizen.hasThirdpartyCare,
                "indicadorGestante": this.citizen.isPregnant,
                "indicadorPossuiFamiliarAcolhido": this.trataNaoInformadoModelAPI(this.citizen.hasFamilyAttended),
                "descricaoFamiliarAcolhido": this.citizen.familyAttendedDescription,
                "indicadorAcolhimentoSigiloso": this.trataNaoInformadoModelAPI(this.citizen.isConfidencial),
                "indicadorVitimaViolencia": (this.citizen.isVictimViolence == 'ni') ? '' : this.citizen.isVictimViolence,
                "indicadorAcolhimentoAnterior": this.trataNaoInformadoModelAPI(this.citizen.hasPreviousAttendance),
                "descricaoLocalAcolhimentoAnterior": this.citizen.previousAttendanceDescription,
                "indicadorAmeaca": this.trataNaoInformadoModelAPI(this.citizen.isThreatened),
                "distritos": this.toThreatenedViolencePlaceModelAPI(this.citizen.isThreatened, this.citizen.threatenedPlaceDistricts, (this.citizen.isVictimViolence == '1'), this.citizen.violencePlaceDistricts),
                "indicadorPPCAAM": this.trataNaoInformadoModelAPI(this.citizen.isPPCAAM),
                "indicadorConvalescencia": this.trataNaoInformadoModelAPI(this.citizen.isConvalescence),
                "indicadorProcessoVIJ": this.trataNaoInformadoModelAPI(this.citizen.hasLawsuitVIJ),
                "descricaoProcessoVIJ": this.citizen.lawsuitVIJNumber,
                "indicadorProcessoDEIJ": this.trataNaoInformadoModelAPI(this.citizen.hasLawsuitDEIJ),
                "descricaoProcessoDEIJ": this.citizen.lawsuitNumberDEIJ,
                "codigoVaraInfancia": this.citizen.lawsuitVIJ,
                "indicadorMedicacaoContinua": this.trataNaoInformadoModelAPI(this.citizen.hasContinuosMedicament),
                "descricaoMedicacaoContinua": this.citizen.continuosMedicamentDescription,
                "indicadorAcompanhamentoCAPS": this.trataNaoInformadoModelAPI(this.citizen.hasAttendenceCAPS),
                "descricaoAcompanhamentoCAPS": this.citizen.attendenceCAPSDescription,
                "indicadorOrdemJudicial": this.trataNaoInformadoModelAPI(this.citizen.hasCourtOrdered),
                "descricaoOrdemJudicial": this.citizen.courtOrderedDescription,
                "indicadorPossuiCarroca": this.trataNaoInformadoModelAPI(this.citizen.hasCart),
                "indicadorFazAcompanhamentoServicoSaude": this.trataNaoInformadoModelAPI(this.citizen.hasHealthMonitoring),
                "descricaoAcompanhamentoServicoSaude": this.citizen.healthMonitoringPlace,
                "indicadorPossuiAnimalEstimacao": this.trataNaoInformadoModelAPI(this.citizen.hasPet),
                "enderecoCidadao": this.toEnderecoModelAPI(),
                "deficiencias": this.toDisabilityModelAPI(this.citizen.hasDisability, this.citizen.disabilities, this.citizen.isMobilityAffected),
                "formasCuidado": this.toCareTypeModelAPI(this.citizen.hasThirdpartyCare, this.citizen.careTypes),
                "indicadorMobilidadeAfetada": this.citizen.isMobilityAffected,
                "tiposServicosSolicitados": this.toServiceTypeSecretAttendenceModelAPI(this.citizen.idServiceTypeSecretAttendence),
                "indicadorVagaAcessivel": this.citizen.isAcessibleSpace,
                "descricaoVagaAcessivel": this.citizen.acessibleSpaceDescription,
            }

            return cidadaoModel;
        },
        trataNaoInformadoModelAPI(value){
            if(value == 'ni')
                return '';
            else
                return value;
        },
        toServiceTypeSecretAttendenceModelAPI(value){
            let arr = [];
            if(!isNaN(parseInt(value)))
                arr.push(parseInt(value))
            return arr;
        },
        toAttendanceServiceModelAPI(hasService, attendenceServices){
            let arrServices = [];
            if(hasService){
                if(attendenceServices != null && attendenceServices.length > 0){
                    for (let i = 0; i < attendenceServices.length; i++) {
                        arrServices.push(attendenceServices[i]);
                    }
                }
            }
            return arrServices;
        },
        toThreatenedViolencePlaceModelAPI(hasThreatenedPlace, threatenedPlaceDistricts, hasViolencVictim, violencePlaceDistricts){
            let arrDistricts = [];
            if(hasThreatenedPlace){
                if(threatenedPlaceDistricts != null && threatenedPlaceDistricts.length > 0){
                    for (let i = 0; i < threatenedPlaceDistricts.length; i++) {
                        let newDistrict = { 'codigo': threatenedPlaceDistricts[i].DistritoId, 'descricao': threatenedPlaceDistricts[i].DescricaoDistrito, 'tipoUso': 'A' }
                        arrDistricts.push(newDistrict);
                    }
                }
            }

            if(hasViolencVictim){
                if(violencePlaceDistricts != null && violencePlaceDistricts.length > 0){
                    for (let i = 0; i < violencePlaceDistricts.length; i++) {
                        let newDistrict = { 'codigo': violencePlaceDistricts[i].DistritoId, 'descricao': violencePlaceDistricts[i].DescricaoDistrito, 'tipoUso': 'V' }
                        arrDistricts.push(newDistrict);
                    }
                }
            }

            return arrDistricts;
        },
        toDisabilityModelAPI(hasDisabilities, disabilities){
            let arrDisabilities = [];
            if(hasDisabilities){
                if(disabilities != null && disabilities.length > 0){
                    for(let i= 0; i < disabilities.length; i = i + 1){
                        arrDisabilities.push({ "codigo": disabilities[i].DeficienciaId, "afetaMobilidade":  (disabilities[i].AfetaMobilidade == true) ? 1 : 0});
                    }
                }
            } else {
                this.citizen.mobilityAffected = false;
            }
            return arrDisabilities;
        },
        toCareTypeModelAPI(hasCareType, careTypes){
            let arrCareTypes = [];
            if(hasCareType){
                if(careTypes != null && careTypes.length > 0){
                    for(let i= 0; i < careTypes.length; i = i + 1){
                        arrCareTypes.push(parseInt(careTypes[i].FormaCuidadoId));
                    }
                }
            }
            return arrCareTypes;
        },
        toDocumentoIdentidadeModelAPI(){
            if(this.citizen.DocumentoIdentidade != null){
                return {
                        "numero": this.citizen.DocumentoIdentidade.number,
                        "digito": this.citizen.DocumentoIdentidade.digit,
                        "orgaoEmissor": this.citizen.DocumentoIdentidade.issuer,
                        "uf": this.citizen.DocumentoIdentidade.stateAcronym,
                        "dataEmissao": this.citizen.DocumentoIdentidade.issueDate,
                };
            } else
            {
                return null;
            }
        },
        todocumentoIdentidadeEstrangeiroModelAPI(){
            if(this.citizen.DocumentoIdentidadeEstrangeiro != null){
                return {
                    "numeroRNE": this.citizen.DocumentoIdentidadeEstrangeiro.number,
                    "dataEntradaPais": this.citizen.DocumentoIdentidadeEstrangeiro.immigrationDate,
                    "dataNaturalizacao": this.citizen.DocumentoIdentidadeEstrangeiro.naturalizationDate,
                    "codigoPaisOrigem": this.citizen.DocumentoIdentidadeEstrangeiro.idOriginCountry,
                    "numeroPortariaNaturalizacao": this.citizen.DocumentoIdentidadeEstrangeiro.ordinanceNaturalization,
                    "numeroPassaporte": this.citizen.DocumentoIdentidadeEstrangeiro.passport,
                };
            } else
            {
                return null;
            }
        },               
        toCertidaoNascimentoModelAPI(){
            if(this.citizen.CertidaoNascimento != null){
                if(this.certidaoNova){
                    return {
                        "numeroNovo": this.citizen.CertidaoNascimento.numberNew
                    };
                } else {
                    return {
                        "numero": this.citizen.CertidaoNascimento.number,
                        "livro": this.citizen.CertidaoNascimento.book,
                        "folha": this.citizen.CertidaoNascimento.page,
                        "codigoCidade": this.citizen.CertidaoNascimento.idCity,
                        "nomeDistrito": this.citizen.CertidaoNascimento.districtName,
                        "uf": this.citizen.CertidaoNascimento.stateAcronym,
                        "dataEmissao": this.citizen.CertidaoNascimento.issueDate,
                        "nomeCartorio": this.citizen.CertidaoNascimento.registryName,
                    };
                }
            } else
            {
                return null;
            }
        },
        toEnderecoModelAPI(){
            if(this.citizen.address != null){
                return {
                    "codigoSubprefeitura": this.citizen.address.idBorough,
                    "codigoTipoLogradouro": this.citizen.address.idStreetType,
                    "pontoReferencia": this.citizen.address.landmark,
                    "nomeLogradouro": this.citizen.address.street,
                    "numeroLogradouro": this.citizen.address.number,
                    "complemento": this.citizen.address.complement,
                    "nomeBairro": this.citizen.address.neighborhood,
                    "cep": this.citizen.address.zipcode,
                    "codigoDistrito": this.citizen.address.idDistrict,
                    "codigoCidade": this.citizen.address.idCity                   
                };
            } else
            {
                return null;
            }
        },                
        clearFields(){
            this.citizen = {
                idTypeForm: null,
                idGrid: 0,
                id: '',
                isPrincipal: false,
                principalCitizenRelationship: '',
                citizenSISA: '',
                hasFinancialAutonomy: 'ni',
                name: '',
                socialName: '',
                motherName: '',
                birthDate: '',
                age: '',
                idGender: '',
                idGenderIdentity: '',
                idRace: '',
                idMaritalStatus: '',
                idDependencyDegree: '',
                DocumentoIdentidade: {
                    number: '',
                    digit: '',
                    issuer: '',
                    stateAcronym: '',
                    issueDate: '',
                },
                cpf: '',
                certidaoNascimentoType: '',
                CertidaoNascimento: {
                    number: '',
                    book: '',
                    page: '',
                    idCity: '',
                    districtName: '',
                    stateAcronym: '',
                    numberNew: '',
                },
                nationality: '',
                DocumentoIdentidadeEstrangeiro: {
                    number: '',
                    immigrationDate: '',
                    naturalizationDate: '',
                    idOriginCountry: '',
                    ordinanceNaturalization: '',
                    passport: ''
                },
                hasDisability: 'false',
                isMobilityAffected: '',
                isAcessibleSpace: '',
                acessibleSpaceDescription: '',
                hasPrognosis: '',
                prognosisDescription: '',
                hasAssistiveTechnology: '',
                hasThirdpartyCare: '',
                isPregnant: '',
                hasFamilyAttended: 'ni',
                familyAttendedDescription: '',
                isConfidencial: '2',
                isVictimViolence: 'ni',
                hasPreviousAttendance: 'ni',
                previousAttendanceDescription: '',
                isThreatened: 'ni',
                threatenedPlaceDescription: '',
                threatenedPlaceDistricts: [],
                violencePlaceDistricts: [],
                isPPCAAM: 'ni',
                isConvalescence: 'ni',
                hasLawsuitVIJ: 'ni',
                lawsuitVIJNumber: '',
                lawsuitVIJ: '',
                hasLawsuitDEIJ: '',
                lawsuitNumberDEIJ: '',
                hasCourtOrdered: 'ni',
                courtOrderedDescription: '',
                hasContinuosMedicament: 'ni',
                continuosMedicamentDescription: '',
                hasAttendenceCAPS: 'ni',
                attendenceCAPSDescription: '',
                hasCart: 'ni',
                hasHealthMonitoring: 'ni',
                healthMonitoringPlace: '',
                hasPet: 'ni',
                address: {
                    idStreetType: '',
                    idBorough: '',
                    idDistrict: '',
                    landmark: '',
                    street: '',
                    number: '',
                    complement: '',
                    neighborhood: '',
                    zipcode: '',
                    idCity: '',
                    stateAcronym: ''
                },
                disabilities: [],
                careTypes: [],
                idServiceTypeSecretAttendence: []
            };
            this.resetForm();
        },
        initDisabledForm(){
            if(this.citizenUpdatable == null || this.citizenUpdatable == ''){
                this.resetForm();
            } else {
                (this.isTrueValue(this.citizenUpdatable.isConvalescence)) ? this.radioClick('conva_S'): this.radioClick('conva_X');
                (this.isTrueValue(this.citizenUpdatable.hasPreviousAttendance)) ? this.radioClick('prevAtt_S') : this.radioClick('prevAtt_X');
                (this.isTrueValue(this.citizenUpdatable.hasFamilyAttended)) ? this.radioClick('att_S') : this.radioClick('att_X');
                (this.isTrueValue(this.citizenUpdatable.hasContinuosMedicament)) ? this.radioClick('med_S') : this.radioClick('med_X');
                (this.isTrueValue(this.citizenUpdatable.isThreatened)) ? this.radioClick('thr_S') : this.radioClick('thr_X');
                (this.isTrueValue(this.citizenUpdatable.isVictimViolence)) ? this.radioClick('vln_S') : this.radioClick('vln_X');
                (this.isTrueValue(this.citizenUpdatable.hasHealthMonitoring)) ? this.radioClick('hmon_S') : this.radioClick('hmon_X');
                (this.isTrueValue(this.citizenUpdatable.hasLawsuitVIJ)) ? this.radioClick('vij_S') : this.radioClick('vij_X');
                (this.isTrueValue(this.citizenUpdatable.hasCourtOrdered)) ? this.radioClick('cor_S') : this.radioClick('cor_X');
                (this.isTrueValue(this.citizenUpdatable.hasLawsuitDEIJ)) ? this.radioClick('dei_S') : this.radioClick('dei_X');
                (this.isTrueValue(this.citizenUpdatable.hasAttendenceCAPS)) ? this.radioClick('atCaps_S') : this.radioClick('atCaps_X');
                (this.isTrueValue(this.citizenUpdatable.isConfidencial)) ? this.radioClick('atCnf_S') : this.radioClick('atCnf_X');
                (this.isTrueValue(this.citizenUpdatable.isAcessibleSpace)) ? this.radioClick('acSpc_S') : this.radioClick('acSpc_N');
                (this.isTrueValue(this.citizenUpdatable.hasDisability)) ? this.radioClick('disab_S') : this.radioClick('disab_N');
                (this.isTrueValue(this.citizenUpdatable.hasThirdpartyCare)) ? this.radioClick('trdPrt_S') : this.radioClick('trdPrt_X');
                if(!this.isNullOrEmpty(this.citizenUpdatable.CertidaoNascimento.stateAcronym))
                    this.loadCities(this.citizenUpdatable.CertidaoNascimento.stateAcronym,'certidaoNascimento')
                this.certidaoNova = (this.citizenUpdatable.certidaoNascimentoType == 'N');

            }
            this.checkIfPregnantFieldEnabled();
        },
        isTrueValue(value){
            let isTrue = ((value != undefined) && (value == "true" || value == "1" || value == true || value === 1));
            return isTrue;
        },               
        async loadGender(){
            await this.$store.dispatch("lists/listTipoSexo");
        },
        async loadGenderIdentity(){
            await this.$store.dispatch("lists/listIdentidadeSexual");
        },
        async loadCities(item, type){
            if(item != null)
            {
                await this.$store.dispatch("lists/listCidadesPorUf", item.toString());
                try{
                    let result = this.$store.state.lists.list;
                    if(result != null){
                        if(type == "address")
                            this.listCityAddress = result;
                        else if(type == "certidaoNascimento")
                            this.listCityCertidaoNascimento = result;
                    }
                }catch (error){
                    this.showSnackbar(error, 'error');
                    console.log(error);
                }
            }
        },
        async loadDesabilityType(){
            await this.$store.dispatch("lists/listDeficiencia");
        },        
        async loadTypeCare(){
            await this.$store.dispatch("lists/listFormasCuidado");
        },        
        async loadRace(){
            await this.$store.dispatch("lists/listRaca");
        }, 
        async loadMaritalStatus(){
            await this.$store.dispatch("lists/listEstadoCivil");
        }, 
        async loadCountry(){
            await this.$store.dispatch("lists/listPais");
        },
        async loadServiceTypeAttendedSecret(){
            await this.$store.dispatch("lists/listTipologiaServicoAcolhimentoSigiloso");
        }, 
        async loadService(){
            await this.$store.dispatch("lists/listServico");
        },
        async loadAllDistrict(){
            try {
                await this.$store.dispatch("lists/listDistritos",null);
                this.listAllDistrict = this.$store.state.lists.list;
            } catch (error) {
                this.showSnackbar(error, 'error');
            }
        },
        async loadPregnantEnable(){
            await this.$store.dispatch("lists/getListPregnantEnable");
        },                    
        async loadNationality(){
            await this.$store.dispatch("lists/listNacionalidade");
        }, 
        async loadDependencyDegree(){
            await this.$store.dispatch("lists/listGrauDependencia");
        },
        async loadLawSuitVIJ(){
            await this.$store.dispatch("lists/listVIJ");
        },                   
        radioClick(item, clearTextField = true){
            switch (item) {
                case 'vij_N':
                case 'vij_X':
                    if(clearTextField)
                        this.citizen.lawsuitVIJNumber = "";        
                        this.citizen.lawsuitVIJ = '';
                    this.isVijDisabled = true;
                    break;
                case 'vij_S':
                    this.isVijDisabled = false;
                    break;
                case 'hmon_N':
                case 'hmon_X':
                    if(clearTextField)                    
                        this.citizen.healthMonitoringPlace = "";        
                    this.ishMonDisabled = true;
                    break;
                case 'hmon_S':
                    this.ishMonDisabled = false;
                    break;
                case 'thr_N':
                case 'thr_X':
                    if(clearTextField){                    
                        this.citizen.threatenedPlaceDistricts = [];
                    }
                    break;
                case 'vln_N':
                case 'vln_X':
                    if(clearTextField){                    
                        this.citizen.violencePlaceDistricts = [];
                    }
                    break;
                case 'med_N':
                case 'med_X':
                    if(clearTextField)                    
                        this.citizen.continuosMedicamentDescription = "";        
                    this.isMedDisabled = true;
                    break;
                case 'med_S':
                    this.isMedDisabled = false;
                    break;
                case 'att_N':
                case 'att_X':
                    if(clearTextField){                    
                        this.citizen.familyAttendedDescription = "";
                    }
                    this.isAttFamDisabled = true;
                    break;
                case 'att_S':
                    this.isAttFamDisabled = false;
                    break;
                case 'prevAtt_N':
                case 'prevAtt_X':
                    if(clearTextField){                    
                        this.citizen.previousAttendanceDescription = "";
                    }
                    this.isPrevAttDisabled = true;
                    break;
                case 'prevAtt_S':
                    this.isPrevAttDisabled = false;
                    break;
                case 'conva_N':
                case 'conva_X':
                    if(clearTextField)                    
                        this.citizen.prognosisDescription = "";        
                    break;
                case 'conva_S':
                    break;
                case 'disab_N':
                    if(clearTextField)                    
                        this.citizen.disabilities = [];
                    this.citizen.hasDisability = 'false';
                    break;
                case 'disab_X':
                    if(clearTextField)                    
                        this.citizen.disabilities = [];
                    this.citizen.hasDisability = '';
                    break;
                case 'disab_S':
                    this.citizen.hasDisability = 'true';
                    break;
                case 'trdPrt_N':
                case 'trdPrt_X':
                    if(clearTextField)                    
                        this.citizen.careTypes = [];
                    break;
                case 'atCaps_N':
                case 'atCaps_X':
                    if(clearTextField){                    
                        this.citizen.attendenceCAPSDescription = '';
                    }
                    break;
                case "atCnf_N":
                case "atCnf_X":
                    if(clearTextField)
                        this.citizen.idServiceTypeSecretAttendence = [];
                    break;
                case "acSpc_N":
                    if(clearTextField)
                        this.citizen.acessibleSpaceDescription = '';
                    break;
                case "cor_N":
                case "cor_X":
                    if(clearTextField)
                        this.citizen.courtOrderedDescription = '';
                    break;
                case "dei_N":
                case "dei_X":
                    if(clearTextField)
                        this.citizen.lawsuitNumberDEIJ = '';                        
                    break;                    
                default:
                    break;
            }
        },
        chkPrincipal(isChecked){
                this.isPrincipal = isChecked;
                this.isPrincpalRelDisabled = isChecked;
                if(isChecked)
                    this.citizen.principalCitizenRelationship = '';
        },
        isValidDate(value){
            if(value == null)
                return true;

            var mm = moment(value);
            let msg = '';
            let valid = mm.isValid();

            if(!valid){
                msg = "Data informada inválida";
            } else {
                if((mm < this.rangeYearValid.min) || (mm > this.rangeYearValid.max)){
                    valid = false;
                    msg = "Data informada com ano inválido";
                }
            }
            return valid || msg;
        },
        setRangeYearValid(){
            this.rangeYearValid = {
                min: moment([1800,1,1]),
                max: moment(),
            };
        },
        formValidate(){
            let valid = true;
            let msg = [];
            let retValidacao = '';
            if(this.$parent.$parent.tipoPerfilSolicitacao == "I" && this.$parent.$parent.listCitizen.length > 1){
                    msg.push("Perfil de solicitação não permite mais que um cidadão");
                    return { status: false, message: msg.join(',\n') };
            }

            if(this.citizen.name.trim().length == 0){
                this.citizen.name = '';
                msg.push("Nome do cidadão é obrigatório.");
                valid = false;
            } else {
                if(!this.checkContainsLettersNumbersBlankSpaces(this.citizen.name)){
                    msg.push("Nome do cidadão com conteúdo inválido, somente é permitido letras, números e espaços.");
                    valid = false;
                }
            }

            if(this.citizen.motherName.trim().length == 0){
                this.citizen.motherName = '';
                msg.push("Nome da mãe do cidadão é obrigatório.");
                valid = false;
            } else {
                if(!this.checkContainsLettersNumbersBlankSpaces(this.citizen.motherName)){
                    msg.push("Nome da mãe do cidadão com conteúdo inválido, somente é permitido letras, números e espaços.");
                    valid = false;
                }
            }

            if(this.citizen.socialName.length > 0 && this.citizen.socialName.trim().length == 0){
                this.citizen.socialName = '';
                msg.push("Nome Social não pode conter apenas espaços.");
                valid = false;
            } else {
                if(!this.checkContainsLettersNumbersBlankSpaces(this.citizen.socialName)){
                    msg.push("Nome Social do cidadão com conteúdo inválido, somente é permitido letras, números e espaços.");
                    valid = false;
                }
            }

            if(this.citizen.DocumentoIdentidade != null && this.citizen.DocumentoIdentidade.issueDate){
                retValidacao = this.isValidDate(this.citizen.DocumentoIdentidade.issueDate);
                if(retValidacao != true){
                    msg.push("Documento de Identidade[Data de Nascimento]: " + retValidacao);
                    valid = false;
                }
            }
            if(this.citizen.CertidaoNascimento.issueDate != null && this.citizen.CertidaoNascimento.issueDate){
                retValidacao = this.isValidDate(this.citizen.CertidaoNascimento.issueDate);
                if(retValidacao != true){
                    msg.push("Certidão de Nascimento[Data de Emissão]: " + retValidacao);
                    valid = false;
                }
            }

            if((this.citizen.nationality == 2 || this.citizen.nationality == 3) 
                && (this.citizen.DocumentoIdentidadeEstrangeiro.idOriginCountry == null 
                    || this.citizen.DocumentoIdentidadeEstrangeiro.idOriginCountry.length == 0)
                )
            {
                    msg.push("Estrangeiro ou Naturalizado[País de Origem]: Foi informado que é estrageiro ou naturalizado mas não foi indicado o país de origem.");
                    valid = false;
            }

            if(this.citizen.DocumentoIdentidadeEstrangeiro.immigrationDate != null && this.citizen.DocumentoIdentidadeEstrangeiro.immigrationDate){
                retValidacao = this.isValidDate(this.citizen.DocumentoIdentidadeEstrangeiro.immigrationDate);
                if(retValidacao != true){
                    msg.push("Estrangeiro[Data de Imigração]: " + retValidacao);
                    valid = false;
                }
            }            
            if(this.citizen.DocumentoIdentidadeEstrangeiro.naturalizationDate != null && this.citizen.DocumentoIdentidadeEstrangeiro.naturalizationDate){
                retValidacao = this.isValidDate(this.citizen.DocumentoIdentidadeEstrangeiro.naturalizationDate);
                if(retValidacao != true){
                    msg.push("Estrangeiro[Data de Naturalização]: " + retValidacao);
                    valid = false;
                }
            }

            if(this.isNullOrEmpty(this.citizen.isAcessibleSpace)){
                    msg.push("Necessita vaga acessível é obrigatório.");
                    valid = false;
            }

            if(this.isNullOrEmpty(this.citizen.hasThirdpartyCare))
            {
                    msg.push("Necessita de cuidados de terceiros é obrigatório.");                    
                    valid = false;
            }
            
            if(this.citizen.hasThirdpartyCare != null && this.convertToBoolean(this.citizen.hasThirdpartyCare)){
                retValidacao = (this.citizen.careTypes != null && this.citizen.careTypes.length > 0);
                if(retValidacao != true){
                    msg.push("Cuidados de Terceiros: Foi indicado que o cidadão necessita de cuidados de terceiros, mas não foi selecionado algum.");
                    valid = false;
                }
            }
            
            if(this.isNullOrEmpty(this.citizen.hasDisability)){
                    msg.push("Possui deficiências é obrigatório.");
                    valid = false;
            }

            if(this.citizen.hasDisability != null && this.isTrueValue(this.citizen.hasDisability) == true){
                retValidacao = (this.citizen.disabilities != null && this.citizen.disabilities.length > 0);
                if(retValidacao != true){
                    msg.push("Deficiência: Foi indicado que possui deficiência, mas não foi selecionada alguma.");
                    valid = false;
                }
            } 
             
            
                                  
            if(this.citizen.isConvalescence != null && this.convertToBoolean(this.citizen.isConvalescence)){
                retValidacao = (this.citizen.prognosisDescription != null && String(this.citizen.prognosisDescription).trim().length > 0);
                if(retValidacao != true){
                    msg.push("Prognóstico: Foi indicado que o cidadão está em convalescência, mas não foi descrito um prognóstico.");
                    valid = false;
                }
            } 
            if(this.citizen.hasPreviousAttendance != null && this.convertToBoolean(this.citizen.hasPreviousAttendance)){
                retValidacao = (this.citizen.previousAttendanceDescription != null && this.citizen.previousAttendanceDescription.trim().length > 0);
                if(retValidacao != true){
                    msg.push("Cidadão Acolhido: Foi indicado que o cidadão foi acolhido anteriormente, mas não foi descrito o local.");                    
                    valid = false;
                }
            }
            if(this.citizen.hasFamilyAttended != null && this.convertToBoolean(this.citizen.hasFamilyAttended)){
                retValidacao = (this.citizen.familyAttendedDescription != null && this.citizen.familyAttendedDescription.trim().length > 0);
                if(retValidacao != true){
                    msg.push("Familiar Acolhido: Foi indicado que o cidadão tem familiar acolhido, mas não foi descrito algum.");                    
                    valid = false;
                    
                }
            }  
            if(this.citizen.hasContinuosMedicament != null && this.convertToBoolean(this.citizen.hasContinuosMedicament)){
                retValidacao = (this.citizen.continuosMedicamentDescription != null && this.citizen.continuosMedicamentDescription.trim().length > 0);
                if(retValidacao != true){
                    msg.push("Uso de Medicamento: Foi indicado que o cidadão faz uso de medicamento contínuo, mas não foi descrito algum.");                    
                    valid = false;
                }
            }  
            if(this.citizen.isThreatened != null && this.convertToBoolean(this.citizen.isThreatened)){
                retValidacao = (this.citizen.threatenedPlaceDistricts != null && this.citizen.threatenedPlaceDistricts.length > 0)
                if(retValidacao != true){
                    msg.push("Está sob ameaça de morte?: Foi indicado que o cidadão encontra-se ameaçado, mas não foi descrito local.");                    
                    valid = false;
                }
            }
            if(this.citizen.isVictimViolence != null && this.convertToBoolean(this.citizen.isVictimViolence)){
                retValidacao = (this.citizen.violencePlaceDistricts != null && this.citizen.violencePlaceDistricts.length > 0)
                if(retValidacao != true){
                    msg.push("Vítima de violência?: Foi indicado que o cidadão encontra-se ameaçado, mas não foi descrito local.");                    
                    valid = false;
                }
            }            
            if(this.citizen.hasHealthMonitoring != null && this.convertToBoolean(this.citizen.hasHealthMonitoring)){
                retValidacao = (this.citizen.healthMonitoringPlace != null && this.citizen.healthMonitoringPlace.trim().length > 0);
                if(retValidacao != true){
                    msg.push("Acompanhamento de saúde: Foi indicado que o cidadão faz acompanhamento específico de saúde, mas não foi descrito o local.");                    
                    valid = false;
                }
            } 

            if(this.citizen.hasAttendenceCAPS != null && this.convertToBoolean(this.citizen.hasAttendenceCAPS)){
                retValidacao = (this.citizen.attendenceCAPSDescription != null && this.citizen.attendenceCAPSDescription.trim().length > 0);
                if(retValidacao != true){
                    msg.push("Acompanhamento CAPS: Foi indicado que o cidadão realiza acompanhamento no CAPS, mas não foi descrito o local.");                    
                    valid = false;
                }
            } 

            if(this.citizen.hasLawsuitVIJ != null && this.convertToBoolean(this.citizen.hasLawsuitVIJ)){
                retValidacao = (this.citizen.lawsuitVIJ != null && this.citizen.lawsuitVIJ.length > 0);
                if(retValidacao != true){
                    msg.push("Possui processo em VIJ: Foi indicado que o cidadão possui processo na VIJ, mas não indicada a Vara da Infância.");                    
                    valid = false;
                }
            }
            if(this.citizen.hasCourtOrdered != null && this.convertToBoolean(this.citizen.hasCourtOrdered)){
                retValidacao = (this.citizen.courtOrderedDescription != null && this.citizen.courtOrderedDescription.trim().length > 0);
                if(retValidacao != true){
                    msg.push("Possui Ordem Judicial: Foi indicado que o cidadão possui ordem judicial, mas não preenchido o campo de Determinação Judicial.");                    
                    valid = false;
                }
            }     

            if(this.currentAge >= 60 && this.isNullOrEmpty(this.citizen.idDependencyDegree)){
                msg.push("Foi indicado que o cidadão possui 60 anos ou mais de idade, porém não foi informado o grau de dependência.");                    
                valid = false;
            }             
            /*Validar se Cidadao tem 18 anos ou Mais e perfil é Casal*/
            if(this.currentAge < 18 && this.$parent.$parent.tipoPerfilSolicitacao == "C"){
                msg.push("Para o Perfil de Solicitação Casal, não é permitido que o cidadão seja menor que 18 anos.");                    
                valid = false;
            } 

            if(!this.checkFieldsCertidaoNascimento()){
                msg.push("Caso um dos campos da Certidão de Nascimento seja preenchido, todos devem ser preenchidos.");                    
                valid = false;
            }  
            if(!this.checkFieldsRG()){
                msg.push("Caso um dos campos do RG seja preenchido, todos devem ser preenchidos.");                    
                valid = false;
            }

            let nrCpfTela = document.getElementById('numeroDoCPF').value;
            if(nrCpfTela != null && nrCpfTela != undefined && nrCpfTela.length > 0){
                if(!this.validateCpf(nrCpfTela)){
                    msg.push("Número de CPF inválido.");                    
                    valid = false;
                }
            } else if(this.citizen.cpf != null && this.citizen.cpf != undefined && this.citizen.cpf.length > 0){
                if(!this.validateCpf(this.citizen.cpf)){
                    msg.push("Número de CPF inválido.");                    
                    valid = false;
                }
            }       
            let idServiceSelect = this.citizen.idServiceTypeSecretAttendence;    
            if(this.isTrueValue(this.citizen.isConfidencial) && (idServiceSelect == null || idServiceSelect == undefined || idServiceSelect.length == 0)){
                msg.push("Foi indicado que é acolhimento sigiloso, mas não foi informada a tipologia.");                    
                valid = false;
            }      

            if(this.isTrueValue(this.citizen.isAcessibleSpace))
            {
                retValidacao = (this.citizen.acessibleSpaceDescription != null && this.citizen.acessibleSpaceDescription.trim().length > 0);
                if(retValidacao != true)
                {
                    msg.push("Foi indicado que necessita de vaga acessível, mas nenhuma justificativa foi informada.");                    
                    valid = false;
                }
            }

            return { status: valid, message: msg };
        },
        checkFieldsCertidaoNascimento(){
            if(!this.isNullOrEmpty(this.citizen.CertidaoNascimento.book)
                || !this.isNullOrEmpty(this.citizen.CertidaoNascimento.page)
                || !this.isNullOrEmpty(this.citizen.CertidaoNascimento.idCity)
                || !this.isNullOrEmpty(this.citizen.CertidaoNascimento.stateAcronym)
                || !this.isNullOrEmpty(this.citizen.CertidaoNascimento.number))
                {
                    let allFilled = (!this.isNullOrEmpty(this.citizen.CertidaoNascimento.book)
                                        && !this.isNullOrEmpty(this.citizen.CertidaoNascimento.page)
                                        && !this.isNullOrEmpty(this.citizen.CertidaoNascimento.idCity)
                                        && !this.isNullOrEmpty(this.citizen.CertidaoNascimento.stateAcronym)
                                        && !this.isNullOrEmpty(this.citizen.CertidaoNascimento.number));
                    
                    return allFilled;
                }

            return true;
        },
        checkFieldsRG(){
            if(!this.isNullOrEmpty(this.citizen.DocumentoIdentidade.number)
                || !this.isNullOrEmpty(this.citizen.DocumentoIdentidade.digit)
                || !this.isNullOrEmpty(this.citizen.DocumentoIdentidade.issuer)
                || !this.isNullOrEmpty(this.citizen.DocumentoIdentidade.stateAcronym)){
                    let isFilled = !this.isNullOrEmpty(this.citizen.DocumentoIdentidade.number)
                                    && !this.isNullOrEmpty(this.citizen.DocumentoIdentidade.issuer)
                                    && !this.isNullOrEmpty(this.citizen.DocumentoIdentidade.stateAcronym);
                    
                    return isFilled;
                }
            return true;
        },
        isNullOrEmpty(value){
            let isEmpty = (value == null || value == undefined || value == '' || value.length == 0);
            return isEmpty;
        },
        verifyMaxLenght(event, type) {
            const value = event.target.value
            if(type == 'cpf'){
                if (String(value).length > 11) {
                    this.citizen.cpf = value.substring(0,11);
                }
            }
        },
        convertToBoolean(value){
            if(value == null || value == '' || value == 'ni')
                return null;
            if(value == "true" || value == "True" || value == "1" || value == true || value === 1)
                return true;

            return false;
        },
        resetForm(){
            let value = false;
            this.isVijDisabled = value;
            this.ishMonDisabled = value;
            this.isMedDisabled = value;
            this.isAttFamDisabled = value;
            this.isPrevAttDisabled = value;
            this.isPrincpalRelDisabled = value;
            this.showFormPrgnt = false;
            this.showGrpForeign = false;
            this.certidaoNova = false;
            this.radioClick('prog_X');
            this.radioClick('prevAtt_X');
            this.radioClick('att_X');
            this.radioClick('med_X');
            this.radioClick('thr_X');
            this.radioClick('vln_X');
            this.radioClick('hmon_X');
            this.radioClick('vij_X');
            this.radioClick('cor_X');
            this.radioClick('dei_X');
            this.radioClick('disab_X');
            this.radioClick('atCaps_X');
            this.radioClick('atCnf_X');
            this.radioClick('acSpc_N');
            this.radioClick('trdPrt_X');
            this.checkTipoCertidao();
        },
        resetAllTextDependentsRadio(){
            this.radioClick('prog_X');
            this.radioClick('prevAtt_X');
            this.radioClick('att_X');
            this.radioClick('med_X');
            this.radioClick('thr_X');
            this.radioClick('vln_X');
            this.radioClick('hmon_X');
            this.radioClick('vij_X');
            this.radioClick('cor_X');
            this.radioClick('dei_X');
            this.radioClick('acSpc_N');
        }  ,
        manageGroupForeing(id){

            if(id == '-1' || id == '1'){
                this.citizen.DocumentoIdentidadeEstrangeiro.idOriginCountry = '';
                this.citizen.DocumentoIdentidadeEstrangeiro.number = '';
                this.citizen.DocumentoIdentidadeEstrangeiro.passport = '';
            }

            let visibility = (id == '2' || id == '3');
            this.showGrpForeign = visibility;
            if(id == '1'){
                var itemBR = this.listPais.filter((p) => p.NomePais.toUpperCase() == 'BRASIL');
                if(itemBR != null && itemBR.length > 0){
                    this.listPaisFiltrada = itemBR;
                    this.citizen.DocumentoIdentidadeEstrangeiro.idOriginCountry = itemBR[0].PaisOrigemId;
                }
            }
            if(visibility == true){
                this.listPaisFiltrada = this.listPais.filter((p) => p.NomePais.toUpperCase() != 'BRASIL');
            }

            if(visibility){
                let idDistrictThreat = this.citizen.threatenedPlaceDistricts.map(e=>e.DistritoId).indexOf(id);
                this.citizen.threatenedPlaceDistricts.splice(idDistrictThreat,1);                
            }
        },
        arrayRemove(arr, value){
            return arr.filter(function(ele){
                return ele != value;
            });
        },
        getPresentAge(value){
            let presentDay = moment();
            let birthDate = moment(value);
            let valid = birthDate.isValid();
            if(valid){
                this.currentAge = presentDay.diff(birthDate, 'years');
            }
            else {
                this.currentAge = -1;
            }            
            this.checkIfPregnantFieldEnabled();
        },
        checkIfPregnantFieldEnabled(){
            let pregnComb = this.citizen.idGender + '|' + this.citizen.idGenderIdentity;
            
            this.showFormPrgnt = this.getListPregnantEnable.includes(pregnComb) && (this.currentAge >= 11);
            if(!this.showFormPrgnt)
                this.citizen.isPregnant = false;
        },
        openAddDisability(){
            //console.log(this.citizen.disabilities);

            this.$refs.mdDisability.loadDisabilityRequest(this.citizen.disabilities);
            this.showModalDisability = true;
        },
        removeDisability(id){
            let idDisability = this.citizen.disabilities.map(e=>e.DeficienciaId==id);
            this.citizen.disabilities.splice(idDisability,1);
        },
        openAddThirdPartyCare(){
            this.$refs.mdThirdPartyCare.loadThirdpartyCareRequest(this.citizen.careTypes);
            this.showModalThirdPartyCare = true;
        },
        removeThirdPartyCare(id){
            let idThirdPartyCare = this.citizen.careTypes.map(e=>e.FormaCuidadoId==id);
            this.citizen.careTypes.splice(idThirdPartyCare,1);
        },
        openAddDistrictViolence(){
            this.$refs.mdDistrictViolence.loadDistricts(this.listAllDistrict);
            this.$refs.mdDistrictViolence.loadDistrictsRequest(this.citizen.violencePlaceDistricts);
            this.showModalDistrictViolence = true;
        },
        openAddDistrictThreat(){
            this.$refs.mdDistrictThreat.loadDistricts(this.listAllDistrict);
            this.$refs.mdDistrictThreat.loadDistrictsRequest(this.citizen.threatenedPlaceDistricts);
            this.showModalDistrictThreat = true;
        },
        removeDistrictViolence(id){
            let idDistrictViolence = this.citizen.violencePlaceDistricts.map(e=>e.DistritoId).indexOf(id);
            this.citizen.violencePlaceDistricts.splice(idDistrictViolence,1);
        },
        removeDistrictThreat(id){
            let idDistrictThreat = this.citizen.threatenedPlaceDistricts.map(e=>e.DistritoId).indexOf(id);
            this.citizen.threatenedPlaceDistricts.splice(idDistrictThreat,1);
        },
        checkTipoCertidao(){
            if(this.certidaoNova){
                this.citizen.CertidaoNascimento.number = '';
                this.citizen.CertidaoNascimento.book = '';
                this.citizen.CertidaoNascimento.page = '';
                this.citizen.CertidaoNascimento.idCity = '';
                this.citizen.CertidaoNascimento.districtName = '';
                this.citizen.CertidaoNascimento.stateAcronym = '';
            } else {
                this.citizen.CertidaoNascimento.numberNew = '';
            }
        },
        isLettersAndNumbers(e){
            let char = String.fromCharCode(e.keyCode);
            if(/^[A-Za-z ]+$/.test(char)){
                return true;
            } else {
                e.preventDefault();
                return false;
            }
        },
        toUpperRequiredTextCitizenIdentify(){
                this.citizen.name = this.citizen.name.toUpperCase();
                this.citizen.motherName =this.citizen.motherName.toUpperCase();
                this.citizen.socialName =this.citizen.socialName.toUpperCase();
        },
        checkContainsLettersNumbersBlankSpaces(text){
            if(/^[A-Za-z\s]*$/.test(text)){
                return true;
            } else {
                return false;
            }

        },
        getTextAffectedMobility(value){
            return (value == true) ? "Sim" : "Não";
        }       
    },
    mounted(){
        this.loadGender();
        this.loadGenderIdentity();
        this.loadDesabilityType();
        this.loadTypeCare();
        this.loadRace();
        this.loadMaritalStatus();
        this.loadCountry();
        this.loadServiceTypeAttendedSecret();
        this.loadService();
        this.loadAllDistrict();       
        this.setRangeYearValid();
        this.loadPregnantEnable();
        this.loadNationality();
        this.loadDependencyDegree();
        this.loadLawSuitVIJ();
    },
   computed: {
       ...mapGetters('lists',['listDistritos','listTipoSexo','listEstadoCivil','listNacionalidade','listPais','listRaca','listIdentidadeSexual','listFormasCuidado','listTipologiaServicoAcolhimentoSigiloso','listServico','listDeficiencia','getListPregnantEnable','listGrauDependencia','listVIJ']),
       ...mapGetters('common',['getEnabledConvalescence']),
      progressName () {
        return Math.min(100, `${this.citizen.name}`.length * 10)
      },
      progressSocialname () {
        return Math.min(100, `${this.citizen.socialName}`.length * 10)
      },
      progressMothername () {
        return Math.min(100, `${this.citizen.motherName}`.length * 10)
      },
      progressIdgender () {
        return Math.min(100, `${this.citizen.idGender}`.length * 10)
      }
   },
   watch: {
       showModalDisability(value){
           if(value){
               this.$refs.mdDisability.clear();
           }
       },
       showModalThirdPartyCare(value){
           if(value)
            this.$refs.mdThirdPartyCare.clear();
       },
       showModalDistrictThreat(value){
           if(value)
            this.$refs.mdDistrictThreat.clear();
       },
       showModalDistrictViolence(value){
           if(value)
            this.$refs.mdDistrictViolence.clear();
       }

   },
}
</script>
<style scoped>
    ::-webkit-input-placeholder { /* WebKit browsers */
        text-transform: none;
    }
    :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        text-transform: none;
    }
    ::-moz-placeholder { /* Mozilla Firefox 19+ */
        text-transform: none;
    }
    :-ms-input-placeholder { /* Internet Explorer 10+ */
        text-transform: none;
    }
    ::placeholder { /* Recent browsers */
        text-transform: none;
    }
</style>
<style>
    .inputUpperText input {
        text-transform: uppercase;
    }    
</style>